{
  "level": "q307",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:q307",
    "objects": "AREAS.E3:q307.e3",
    "mesh": "TREES.E3:q307.e3"
  },
  "spawn_point": {
    "position": [
      1078.2451302292,
      1295.6376551440637,
      84.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      1078.2451302292,
      1395.6376551440637,
      84.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      200.0,
      584.0,
      60.0
    ],
    "bbox_max": [
      3108.39404296875,
      7450.0,
      1180.0
    ],
    "vertex_count": 702,
    "vertices": [
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        3108.39404296875,
        6871.484375,
        547.115966796875
      ],
      [
        3108.39404296875,
        6871.484375,
        623.0784912109375
      ],
      [
        816.3760375976562,
        7327.39501953125,
        652.46484375
      ],
      [
        1060.0,
        584.0,
        220.0
      ],
      [
        1060.0,
        584.0,
        250.0
      ],
      [
        1014.1599731445312,
        867.8524780273438,
        118.0
      ],
      [
        866.452880859375,
        720.1453857421875,
        118.0
      ],
      [
        866.452880859375,
        720.1453857421875,
        120.0
      ],
      [
        1014.1599731445312,
        867.8524780273438,
        120.0
      ],
      [
        897.8525390625,
        867.8525390625,
        140.0
      ],
      [
        926.1367797851562,
        867.8525390625,
        140.0
      ],
      [
        997.8525390625,
        867.8525390625,
        78.65028381347656
      ],
      [
        904.6011352539062,
        867.8525390625,
        78.65028381347656
      ],
      [
        922.1474609375,
        867.8525390625,
        80.0
      ],
      [
        922.1474609375,
        867.8525390625,
        80.0
      ],
      [
        997.8525390625,
        867.8525390625,
        80.0
      ],
      [
        985.8297119140625,
        867.8525390625,
        118.0
      ],
      [
        980.0,
        867.8525390625,
        118.0
      ],
      [
        926.1368408203125,
        867.8525390625,
        118.0
      ],
      [
        897.8525390625,
        867.8525390625,
        118.0
      ],
      [
        985.8297119140625,
        867.8525390625,
        118.0
      ],
      [
        980.0,
        867.8525390625,
        120.0
      ],
      [
        985.8297119140625,
        867.8525390625,
        120.0
      ],
      [
        897.8525390625,
        867.8525390625,
        120.0
      ],
      [
        926.1368408203125,
        867.8525390625,
        120.0
      ],
      [
        985.8297119140625,
        867.8525390625,
        120.0
      ],
      [
        897.8525390625,
        867.8525390625,
        118.0
      ],
      [
        897.8525390625,
        867.8525390625,
        120.0
      ],
      [
        980.0,
        867.8525390625,
        120.0
      ],
      [
        980.0,
        867.8525390625,
        118.0
      ],
      [
        1630.0,
        1450.0,
        138.0
      ],
      [
        1630.0,
        1450.0,
        140.0
      ],
      [
        1630.0,
        1450.0,
        138.0
      ],
      [
        1630.0,
        1470.0,
        138.0
      ],
      [
        1630.0,
        1470.0,
        140.0
      ],
      [
        1655.0,
        1468.0,
        138.0
      ],
      [
        1630.0,
        1468.0,
        138.0
      ],
      [
        1630.0,
        1450.0001220703125,
        120.0
      ],
      [
        1630.0,
        1450.0,
        120.0
      ],
      [
        1633.0,
        1140.0,
        120.0
      ],
      [
        1657.0,
        1150.0,
        138.0
      ],
      [
        1657.0,
        1140.0,
        138.0
      ],
      [
        1657.0,
        1140.0,
        138.0
      ],
      [
        1690.0,
        1120.0,
        140.0
      ],
      [
        1690.0,
        1200.0,
        140.0
      ],
      [
        1690.0,
        1120.0,
        140.0
      ],
      [
        1690.0,
        995.0,
        140.0
      ],
      [
        1710.0,
        1220.0,
        140.0
      ],
      [
        1690.0,
        1200.0,
        140.0
      ],
      [
        1547.9998779296875,
        1467.9998779296875,
        138.0
      ],
      [
        1547.9998779296875,
        1480.0,
        138.0
      ],
      [
        1547.9998779296875,
        1467.9998779296875,
        138.0
      ],
      [
        1548.0,
        1450.0,
        138.0
      ],
      [
        1547.9998779296875,
        1684.999755859375,
        138.0
      ],
      [
        1547.9998779296875,
        1480.0,
        138.0
      ],
      [
        1547.9998779296875,
        1507.455810546875,
        138.0
      ],
      [
        1587.455810546875,
        1467.9998779296875,
        138.0
      ],
      [
        1587.455810546875,
        1467.9998779296875,
        138.0
      ],
      [
        1630.0,
        1468.0,
        138.0
      ],
      [
        1530.0,
        1450.0,
        120.0
      ],
      [
        1530.0,
        1450.0,
        138.0
      ],
      [
        1500.0,
        1450.0,
        138.0
      ],
      [
        1480.0,
        1450.0,
        138.0
      ],
      [
        1530.0,
        1450.0,
        140.0
      ],
      [
        1530.0,
        1450.0,
        138.0
      ],
      [
        1480.0,
        1350.0,
        140.0
      ],
      [
        1480.0,
        1350.0,
        115.65217590332031
      ],
      [
        1480.0,
        1120.0,
        100.0
      ],
      [
        1480.0,
        1170.0,
        100.0
      ],
      [
        1480.0,
        1170.0,
        140.0
      ],
      [
        1480.0,
        1170.0,
        100.0
      ],
      [
        1570.0001220703125,
        1440.0,
        124.99991607666016
      ],
      [
        1570.0001220703125,
        1440.0,
        122.99993896484375
      ],
      [
        1570.0001220703125,
        1440.0,
        122.99993896484375
      ],
      [
        1576.0,
        1445.9998779296875,
        120.0
      ],
      [
        1480.0,
        1140.0,
        120.0
      ],
      [
        1480.0,
        1120.0,
        120.0
      ],
      [
        1480.0,
        1120.0,
        118.0
      ],
      [
        1480.0,
        1140.0,
        118.0
      ],
      [
        1480.0,
        1140.0,
        120.0
      ],
      [
        1480.0,
        1140.0,
        118.0
      ],
      [
        1617.0,
        1170.0,
        118.0
      ],
      [
        1617.0,
        1160.0,
        118.0
      ],
      [
        1617.0,
        1160.0,
        118.0
      ],
      [
        1555.0,
        1120.0,
        130.0
      ],
      [
        1615.0,
        1120.0,
        130.0
      ],
      [
        1480.0,
        1120.0,
        130.0
      ],
      [
        1535.0,
        1120.0,
        130.0
      ],
      [
        1480.0,
        1130.0,
        140.0
      ],
      [
        1535.0,
        1128.0,
        138.0
      ],
      [
        1535.0,
        1120.0,
        138.0
      ],
      [
        1555.0,
        1120.0,
        138.0
      ],
      [
        1555.0,
        1128.0,
        138.0
      ],
      [
        1555.0,
        1128.0,
        138.0
      ],
      [
        1555.0,
        1120.0,
        140.0
      ],
      [
        1555.0,
        1120.0,
        138.0
      ],
      [
        1535.0,
        1120.0,
        138.0
      ],
      [
        1535.0,
        1128.0,
        138.0
      ],
      [
        1535.0,
        1130.0,
        140.0
      ],
      [
        1535.0,
        1120.0,
        140.0
      ],
      [
        1555.0,
        1120.0,
        130.0
      ],
      [
        1480.0,
        1350.0,
        115.65217590332031
      ],
      [
        1480.0,
        1419.553466796875,
        138.0
      ],
      [
        1480.0,
        1419.553466796875,
        138.0
      ],
      [
        1480.0,
        1380.0,
        138.0
      ],
      [
        1544.0,
        1440.0,
        138.0
      ],
      [
        1250.0,
        1120.0,
        120.0
      ],
      [
        1270.0001220703125,
        1140.0,
        120.0
      ],
      [
        1270.0001220703125,
        1140.0,
        118.0
      ],
      [
        1250.0,
        1120.0,
        118.0
      ],
      [
        1270.0001220703125,
        1140.0,
        118.0
      ],
      [
        1270.0001220703125,
        1140.0,
        120.0
      ],
      [
        1336.0,
        1160.0,
        118.0
      ],
      [
        1336.0,
        1150.0,
        118.0
      ],
      [
        1336.0,
        1150.0,
        118.0
      ],
      [
        1346.0,
        1170.0,
        120.0
      ],
      [
        1346.0,
        1160.0,
        120.0
      ],
      [
        1346.0,
        1160.0,
        120.0
      ],
      [
        1395.0,
        1120.0,
        130.0
      ],
      [
        1455.0,
        1120.0,
        130.0
      ],
      [
        1475.0,
        1120.0,
        130.0
      ],
      [
        1455.0,
        1128.0,
        138.0
      ],
      [
        1455.0,
        1120.0,
        138.0
      ],
      [
        1475.0,
        1120.0,
        138.0
      ],
      [
        1475.0,
        1128.0,
        138.0
      ],
      [
        1455.0,
        1120.0,
        138.0
      ],
      [
        1455.0,
        1128.0,
        138.0
      ],
      [
        1455.0,
        1130.0,
        140.0
      ],
      [
        1455.0,
        1120.0,
        140.0
      ],
      [
        1475.0,
        1128.0,
        138.0
      ],
      [
        1475.0,
        1120.0,
        140.0
      ],
      [
        1475.0,
        1120.0,
        138.0
      ],
      [
        1395.0,
        1128.0,
        138.0
      ],
      [
        1395.0,
        1120.0,
        140.0
      ],
      [
        1395.0,
        1120.0,
        138.0
      ],
      [
        1395.0,
        1120.0,
        130.0
      ],
      [
        1475.0,
        1120.0,
        130.0
      ],
      [
        1290.0,
        1160.0,
        138.0
      ],
      [
        1290.0,
        1160.0,
        140.0
      ],
      [
        1290.0,
        1160.0,
        138.0
      ],
      [
        1314.0,
        1160.0,
        138.0
      ],
      [
        1480.0,
        1420.0,
        138.0
      ],
      [
        1265.0,
        1205.0,
        100.0
      ],
      [
        1250.0,
        1190.0,
        100.0
      ],
      [
        1250.0,
        1140.0,
        118.0
      ],
      [
        1250.0,
        1140.0,
        120.0
      ],
      [
        1250.0,
        1140.0,
        118.0
      ],
      [
        1250.0,
        1140.0,
        120.0
      ],
      [
        1555.0,
        1110.0,
        138.0
      ],
      [
        1555.0,
        1120.0,
        138.0
      ],
      [
        1395.0,
        1110.0,
        138.0
      ],
      [
        1395.0,
        1120.0,
        138.0
      ],
      [
        1200.0,
        1460.0,
        140.0
      ],
      [
        1030.0,
        1460.0,
        140.0
      ],
      [
        955.0,
        1655.0,
        140.0
      ],
      [
        980.0,
        1670.0,
        140.0
      ],
      [
        945.0,
        1595.0,
        140.0
      ],
      [
        960.0,
        1570.0,
        140.0
      ],
      [
        960.0,
        1570.0,
        140.0
      ],
      [
        980.0,
        1590.0,
        140.0
      ],
      [
        980.0,
        1460.0,
        80.0
      ],
      [
        890.0,
        1460.0,
        71.0
      ],
      [
        945.5584716796875,
        1540.0,
        76.55584716796875
      ],
      [
        890.0,
        1472.83544921875,
        89.1501693725586
      ],
      [
        890.0,
        1472.83544921875,
        91.15017700195312
      ],
      [
        945.5584716796875,
        1540.0,
        100.0
      ],
      [
        945.5584716796875,
        1540.0,
        97.99999237060547
      ],
      [
        958.1143188476562,
        1570.0,
        100.0
      ],
      [
        958.1143188476562,
        1555.1787109375,
        100.0
      ],
      [
        958.1143188476562,
        1548.6943359375,
        100.0
      ],
      [
        958.1143798828125,
        1543.6455078125,
        100.0
      ],
      [
        958.1143188476562,
        1548.6943359375,
        100.0
      ],
      [
        958.1143798828125,
        1543.6455078125,
        100.0
      ],
      [
        958.1143798828125,
        1460.0,
        100.0
      ],
      [
        945.5584716796875,
        1460.0,
        100.0
      ],
      [
        933.0026245117188,
        1524.8212890625,
        98.0
      ],
      [
        933.0026245117188,
        1460.0,
        98.0
      ],
      [
        945.5585327148438,
        1460.0,
        98.0
      ],
      [
        890.0,
        1460.0,
        89.1501693725586
      ],
      [
        890.0,
        1460.0,
        91.15017700195312
      ],
      [
        890.0,
        1472.83544921875,
        91.15017700195312
      ],
      [
        890.0,
        1472.83544921875,
        89.1501693725586
      ],
      [
        960.0,
        1550.0,
        100.30035400390625
      ],
      [
        960.0,
        1550.0,
        102.30036926269531
      ],
      [
        980.0,
        1550.0,
        105.48612976074219
      ],
      [
        980.0,
        1550.0,
        103.48612213134766
      ],
      [
        980.0,
        1460.0,
        98.0
      ],
      [
        980.0,
        1460.0,
        100.0
      ],
      [
        960.0,
        1550.0,
        98.0
      ],
      [
        960.0,
        1550.0,
        100.0
      ],
      [
        980.0,
        1550.0,
        100.0
      ],
      [
        980.0,
        1550.0,
        98.0
      ],
      [
        890.0,
        1460.0,
        71.0
      ],
      [
        890.0,
        1472.83544921875,
        120.0
      ],
      [
        890.0,
        1472.83544921875,
        140.0
      ],
      [
        945.5584716796875,
        1540.0,
        140.0
      ],
      [
        960.0,
        1550.0,
        120.0
      ],
      [
        980.0,
        1550.0,
        120.0
      ],
      [
        890.0,
        1460.0,
        120.0
      ],
      [
        890.0,
        1460.0,
        140.0
      ],
      [
        890.0,
        1472.83544921875,
        120.0
      ],
      [
        890.0,
        1460.0,
        100.0
      ],
      [
        890.0,
        1472.83544921875,
        100.0
      ],
      [
        890.0,
        1460.0,
        98.0
      ],
      [
        890.0,
        1460.0,
        98.0
      ],
      [
        890.0,
        1460.0,
        100.0
      ],
      [
        890.0,
        1472.83544921875,
        100.0
      ],
      [
        890.0,
        1472.83544921875,
        98.0
      ],
      [
        1183.0,
        1620.0,
        118.0
      ],
      [
        1036.5,
        1628.55859375,
        118.0
      ],
      [
        1037.2222900390625,
        1629.509521484375,
        120.0
      ],
      [
        1036.5,
        1690.0,
        118.0
      ],
      [
        1037.2222900390625,
        1690.0,
        120.0
      ],
      [
        1037.2222900390625,
        1629.509521484375,
        120.0
      ],
      [
        1036.5,
        1628.55859375,
        118.0
      ],
      [
        1183.0,
        1620.0,
        118.0
      ],
      [
        1200.0,
        1620.0,
        118.0
      ],
      [
        1033.75,
        1620.0,
        118.0
      ],
      [
        1033.75,
        1610.0,
        118.0
      ],
      [
        1033.75,
        1610.0,
        118.0
      ],
      [
        1200.0,
        1590.0,
        100.0
      ],
      [
        1030.0,
        1590.0,
        80.0
      ],
      [
        980.0,
        1622.9208984375,
        100.0
      ],
      [
        1000.0,
        1621.7525634765625,
        100.0
      ],
      [
        1000.0,
        1620.7593994140625,
        98.0
      ],
      [
        980.0,
        1621.927734375,
        98.0
      ],
      [
        1000.0,
        1620.7593994140625,
        98.0
      ],
      [
        1000.0,
        1621.7525634765625,
        100.0
      ],
      [
        980.0,
        1620.0,
        100.0
      ],
      [
        980.0,
        1620.0,
        98.0
      ],
      [
        980.0,
        1590.0,
        80.0
      ],
      [
        1030.0,
        1590.0,
        80.0
      ],
      [
        996.25,
        1618.125,
        98.0
      ],
      [
        996.25,
        1611.875,
        98.0
      ],
      [
        996.25,
        1620.0,
        98.0
      ],
      [
        996.25,
        1618.125,
        98.0
      ],
      [
        996.25,
        1610.0,
        98.0
      ],
      [
        996.25,
        1611.875,
        98.0
      ],
      [
        980.0,
        1610.0,
        100.0
      ],
      [
        980.0,
        1610.0,
        98.0
      ],
      [
        980.0,
        1590.0,
        100.0
      ],
      [
        1000.0,
        1590.0,
        100.0
      ],
      [
        980.0,
        1590.0,
        98.0
      ],
      [
        1000.0,
        1590.0,
        98.0
      ],
      [
        1000.0,
        1590.0,
        98.0
      ],
      [
        1000.0,
        1590.0,
        100.0
      ],
      [
        1037.5947265625,
        1690.0,
        140.0
      ],
      [
        1037.5947265625,
        1639.419189453125,
        140.0
      ],
      [
        1187.731689453125,
        1630.0,
        140.0
      ],
      [
        1037.5947265625,
        1630.0,
        140.0
      ],
      [
        1037.5947265625,
        1630.0,
        140.0
      ],
      [
        980.0,
        1460.0,
        98.0
      ],
      [
        980.0,
        1460.0,
        100.0
      ],
      [
        1030.0,
        1550.0,
        100.0
      ],
      [
        1030.0,
        1550.0,
        98.0
      ],
      [
        1030.0,
        1570.0,
        98.0
      ],
      [
        1030.0,
        1570.0,
        100.0
      ],
      [
        1030.0,
        1460.0,
        100.0
      ],
      [
        1030.0,
        1460.0,
        98.0
      ],
      [
        1030.0,
        1550.0,
        98.0
      ],
      [
        1030.0,
        1550.0,
        100.0
      ],
      [
        1030.0,
        1550.0,
        140.0
      ],
      [
        1030.0,
        1570.0,
        140.0
      ],
      [
        1030.0,
        1460.0,
        140.0
      ],
      [
        1030.0,
        1550.0,
        140.0
      ],
      [
        980.0,
        1460.0,
        80.0
      ],
      [
        1030.0,
        1460.0,
        80.0
      ],
      [
        780.0,
        1420.0,
        60.0
      ],
      [
        980.0,
        1420.0,
        80.0
      ],
      [
        1090.0,
        1420.0,
        87.05882263183594
      ],
      [
        1030.0,
        1420.0,
        80.0
      ],
      [
        980.0,
        1420.0,
        80.0
      ],
      [
        1030.0,
        1420.0,
        80.0
      ],
      [
        1000.0,
        1420.0,
        100.0
      ],
      [
        980.0,
        1420.0,
        100.0
      ],
      [
        890.0,
        1420.0,
        100.0
      ],
      [
        980.0,
        1420.0,
        100.0
      ],
      [
        1000.0,
        1420.0,
        98.0
      ],
      [
        980.0,
        1420.0,
        98.0
      ],
      [
        890.0,
        1420.0,
        98.0
      ],
      [
        980.0,
        1420.0,
        98.0
      ],
      [
        890.0,
        1450.0,
        100.0
      ],
      [
        890.0,
        1450.0,
        98.0
      ],
      [
        820.0,
        1450.0,
        98.0
      ],
      [
        820.0,
        1450.0,
        100.0
      ],
      [
        890.0,
        1450.0,
        98.0
      ],
      [
        890.0,
        1450.0,
        100.0
      ],
      [
        890.0,
        1460.0,
        100.0
      ],
      [
        890.0,
        1460.0,
        98.0
      ],
      [
        1000.0,
        1420.0,
        98.0
      ],
      [
        1000.0,
        1420.0,
        100.0
      ],
      [
        820.0,
        1420.0,
        78.0
      ],
      [
        890.0,
        1420.0,
        98.0
      ],
      [
        1030.0,
        1280.0,
        140.0
      ],
      [
        1030.0,
        1300.0,
        140.0
      ],
      [
        1030.0,
        1280.0,
        140.0
      ],
      [
        1030.0,
        1170.0,
        140.0
      ],
      [
        1030.0,
        1300.0,
        140.0
      ],
      [
        1030.0,
        1390.0,
        140.0
      ],
      [
        1030.0,
        1120.0,
        120.0
      ],
      [
        1030.0,
        1120.0,
        118.0
      ],
      [
        1030.0,
        1120.0,
        130.0
      ],
      [
        1030.0,
        1120.0,
        82.10526275634766
      ],
      [
        1030.0,
        1170.0,
        140.0
      ],
      [
        1200.0,
        1170.0,
        140.0
      ],
      [
        1200.0,
        1300.0,
        140.0
      ],
      [
        1030.0,
        1300.0,
        140.0
      ],
      [
        1030.0,
        1390.0,
        98.0
      ],
      [
        1030.0,
        1390.0,
        100.0
      ],
      [
        1030.0,
        1390.0,
        100.0
      ],
      [
        1030.0,
        1410.0,
        100.0
      ],
      [
        1030.0,
        1410.0,
        98.0
      ],
      [
        1030.0,
        1390.0,
        98.0
      ],
      [
        1250.0,
        1170.0,
        100.0
      ],
      [
        1215.0,
        1170.0,
        120.0
      ],
      [
        1235.0,
        1170.0,
        120.0
      ],
      [
        1235.0,
        1170.0,
        118.0
      ],
      [
        1215.0,
        1170.0,
        118.0
      ],
      [
        1215.0,
        1170.0,
        120.0
      ],
      [
        1215.0,
        1170.0,
        118.0
      ],
      [
        1030.0,
        1120.0,
        82.10526275634766
      ],
      [
        1030.0,
        1120.0,
        118.0
      ],
      [
        1030.0,
        1140.0,
        118.0
      ],
      [
        1030.0,
        1140.0,
        120.0
      ],
      [
        1030.0,
        1120.0,
        120.0
      ],
      [
        1030.0,
        1140.0,
        120.0
      ],
      [
        1030.0,
        1140.0,
        118.0
      ],
      [
        1030.0,
        880.0,
        80.0
      ],
      [
        1030.0,
        930.0,
        80.0
      ],
      [
        1030.0,
        880.0,
        80.0
      ],
      [
        1030.0,
        867.8525390625,
        98.77336120605469
      ],
      [
        1030.0,
        1110.0,
        130.0
      ],
      [
        1189.5999755859375,
        1109.5999755859375,
        140.0
      ],
      [
        1030.0,
        1109.5999755859375,
        140.0
      ],
      [
        1235.0,
        1110.4000244140625,
        120.0
      ],
      [
        1215.0,
        1110.4000244140625,
        120.0
      ],
      [
        1030.0,
        887.8524780273438,
        120.0
      ],
      [
        1030.0,
        867.8524780273438,
        120.0
      ],
      [
        1215.0,
        1110.4801025390625,
        118.0
      ],
      [
        1235.0,
        1110.47998046875,
        118.0
      ],
      [
        1030.0,
        867.8524780273438,
        118.0
      ],
      [
        1030.0,
        887.8524780273438,
        118.0
      ],
      [
        1030.0,
        887.8524780273438,
        118.0
      ],
      [
        1030.0,
        887.8524780273438,
        120.0
      ],
      [
        1215.0,
        1110.4000244140625,
        120.0
      ],
      [
        1215.0,
        1110.4801025390625,
        118.0
      ],
      [
        1050.4000244140625,
        1109.199951171875,
        140.0
      ],
      [
        1050.0,
        1109.5999755859375,
        140.0
      ],
      [
        1160.0,
        1109.5999755859375,
        140.0
      ],
      [
        1159.5999755859375,
        1109.199951171875,
        140.0
      ],
      [
        1163.3333740234375,
        1113.3333740234375,
        140.0
      ],
      [
        1046.6666259765625,
        1113.3333740234375,
        140.0
      ],
      [
        1163.7333984375,
        1113.3333740234375,
        140.0
      ],
      [
        1046.2666015625,
        1113.3333740234375,
        140.0
      ],
      [
        1199.199951171875,
        1119.199951171875,
        140.0
      ],
      [
        1169.5999755859375,
        1119.199951171875,
        140.0
      ],
      [
        1030.0,
        1120.0,
        130.0
      ],
      [
        1040.4000244140625,
        1119.199951171875,
        140.0
      ],
      [
        1030.0,
        1119.199951171875,
        140.0
      ],
      [
        1040.4000244140625,
        1119.199951171875,
        140.0
      ],
      [
        1169.5999755859375,
        1119.199951171875,
        140.0
      ],
      [
        980.0,
        1120.0,
        118.0
      ],
      [
        980.0,
        1120.0,
        120.0
      ],
      [
        980.0,
        1280.0,
        140.0
      ],
      [
        780.0,
        1280.0,
        140.0
      ],
      [
        780.0,
        1130.0,
        110.0
      ],
      [
        980.0,
        1120.0,
        80.0
      ],
      [
        970.0,
        1131.537109375,
        110.0
      ],
      [
        980.0,
        1156.537109375,
        110.0
      ],
      [
        965.8851928710938,
        1120.0,
        110.0
      ],
      [
        970.0,
        1131.537109375,
        110.0
      ],
      [
        980.0,
        1120.0,
        133.9837646484375
      ],
      [
        980.0,
        1143.07421875,
        120.0
      ],
      [
        980.0,
        1143.07421875,
        120.0
      ],
      [
        945.5584716796875,
        1310.0,
        76.55585479736328
      ],
      [
        945.5584716796875,
        1310.0,
        76.55585479736328
      ],
      [
        820.0,
        1310.0,
        140.0
      ],
      [
        980.0,
        1310.0,
        100.0
      ],
      [
        980.0,
        1310.0,
        98.0
      ],
      [
        890.0,
        1377.16455078125,
        100.0
      ],
      [
        890.0,
        1377.16455078125,
        98.0
      ],
      [
        945.5584716796875,
        1310.0,
        98.0
      ],
      [
        945.5584716796875,
        1310.0,
        100.0
      ],
      [
        790.0,
        1320.0,
        100.0
      ],
      [
        790.0,
        1320.0,
        98.0
      ],
      [
        790.0,
        1310.0,
        98.0
      ],
      [
        790.0,
        1310.0,
        100.0
      ],
      [
        890.0,
        1377.16455078125,
        98.0
      ],
      [
        890.0,
        1377.16455078125,
        100.0
      ],
      [
        890.0,
        1400.0,
        100.0
      ],
      [
        890.0,
        1400.0,
        98.0
      ],
      [
        883.0,
        1404.0,
        98.0
      ],
      [
        867.8016357421875,
        1404.0,
        93.6576156616211
      ],
      [
        867.8016357421875,
        1404.0,
        91.6576156616211
      ],
      [
        867.8016357421875,
        1404.0,
        91.6576156616211
      ],
      [
        854.5664672851562,
        1420.0,
        87.87613677978516
      ],
      [
        890.0,
        1377.16455078125,
        140.0
      ],
      [
        890.0,
        1377.16455078125,
        120.0
      ],
      [
        945.5584716796875,
        1310.0,
        140.0
      ],
      [
        890.0,
        1377.16455078125,
        120.0
      ],
      [
        890.0,
        1400.0,
        120.0
      ],
      [
        960.0,
        1300.0,
        120.0
      ],
      [
        980.0,
        1300.0,
        120.0
      ],
      [
        958.1143188476562,
        1301.3056640625,
        100.0
      ],
      [
        958.1143188476562,
        1280.0,
        100.0
      ],
      [
        958.1143798828125,
        1306.3544921875,
        100.0
      ],
      [
        958.1143188476562,
        1301.3056640625,
        100.0
      ],
      [
        958.1143798828125,
        1306.3544921875,
        100.0
      ],
      [
        958.1143798828125,
        1310.0,
        100.0
      ],
      [
        960.0,
        1300.0,
        100.30036163330078
      ],
      [
        980.0,
        1300.0,
        103.48612976074219
      ],
      [
        960.0,
        1300.0,
        100.0
      ],
      [
        960.0,
        1300.0,
        98.0
      ],
      [
        980.0,
        1300.0,
        98.0
      ],
      [
        980.0,
        1300.0,
        100.0
      ],
      [
        990.0,
        1130.0,
        120.0
      ],
      [
        990.0,
        1140.0,
        120.0
      ],
      [
        990.0,
        1120.0,
        120.0
      ],
      [
        980.0,
        1120.0,
        120.0
      ],
      [
        990.0,
        1130.0,
        120.0
      ],
      [
        988.9999389648438,
        1140.0,
        118.0
      ],
      [
        988.9999389648438,
        1131.0,
        118.0
      ],
      [
        988.9999389648438,
        1131.0,
        118.0
      ],
      [
        980.0,
        1120.0,
        118.0
      ],
      [
        988.9999389648438,
        1120.0,
        118.0
      ],
      [
        990.0,
        1140.0,
        120.0
      ],
      [
        988.9999389648438,
        1140.0,
        118.0
      ],
      [
        1000.0,
        1120.0,
        100.0
      ],
      [
        1020.0,
        1246.0,
        100.0
      ],
      [
        1000.0,
        1120.0,
        98.0
      ],
      [
        1020.0,
        1410.0,
        98.0
      ],
      [
        1020.0,
        1390.0,
        98.0
      ],
      [
        1000.0,
        1120.0,
        98.0
      ],
      [
        1000.0,
        1120.0,
        100.0
      ],
      [
        1000.0,
        1386.0,
        98.0
      ],
      [
        1010.0,
        1386.0,
        98.0
      ],
      [
        1000.0,
        1386.0,
        98.0
      ],
      [
        1020.0,
        1390.0,
        98.0
      ],
      [
        1020.0,
        1390.0,
        100.0
      ],
      [
        1010.0,
        1386.0,
        98.0
      ],
      [
        1020.0,
        1120.0,
        81.05262756347656
      ],
      [
        1020.0,
        1145.0,
        80.0
      ],
      [
        1020.0,
        1246.0,
        100.0
      ],
      [
        1030.0,
        1246.0,
        100.0
      ],
      [
        1030.0,
        1206.0,
        120.0
      ],
      [
        1020.0,
        1206.0,
        120.0
      ],
      [
        1020.0000610351562,
        1120.0,
        118.0
      ],
      [
        1020.0000610351562,
        1140.0,
        118.0
      ],
      [
        1020.0000610351562,
        1140.0,
        120.0
      ],
      [
        1020.0000610351562,
        1120.0,
        120.0
      ],
      [
        1020.0000610351562,
        1140.0,
        120.0
      ],
      [
        1020.0000610351562,
        1140.0,
        118.0
      ],
      [
        998.9463500976562,
        867.8525390625,
        80.0
      ],
      [
        950.0,
        1120.0,
        80.0
      ],
      [
        950.0,
        970.0,
        80.0
      ],
      [
        1010.0,
        930.0,
        110.0
      ],
      [
        1010.0,
        1120.0,
        110.0
      ],
      [
        1010.0,
        867.8525390625,
        93.6399154663086
      ],
      [
        960.0,
        930.0,
        110.0
      ],
      [
        780.0,
        930.0,
        110.0
      ],
      [
        950.0,
        1096.0,
        100.0
      ],
      [
        960.0,
        1096.0,
        100.0
      ],
      [
        960.0,
        1096.0,
        100.0
      ],
      [
        964.0,
        970.0,
        110.0
      ],
      [
        964.0,
        990.0,
        110.0
      ],
      [
        960.0,
        1084.0,
        108.0
      ],
      [
        964.0,
        990.0,
        110.0
      ],
      [
        1020.4000244140625,
        1109.5999755859375,
        140.0
      ],
      [
        1020.4000244140625,
        940.4000244140625,
        140.0
      ],
      [
        1019.5999755859375,
        887.8524780273438,
        120.0
      ],
      [
        1019.5999755859375,
        867.8524780273438,
        120.0
      ],
      [
        1019.5199584960938,
        867.8524780273438,
        118.0
      ],
      [
        1019.5199584960938,
        887.8524780273438,
        118.0
      ],
      [
        1019.5199584960938,
        887.8524780273438,
        118.0
      ],
      [
        1019.5999755859375,
        887.8524780273438,
        120.0
      ],
      [
        1020.4000244140625,
        1109.5999755859375,
        140.0
      ],
      [
        1020.7999877929688,
        970.4000244140625,
        140.0
      ],
      [
        1020.3999633789062,
        970.0,
        140.0
      ],
      [
        1020.0,
        1120.0,
        130.0
      ],
      [
        1020.3999633789062,
        1119.199951171875,
        140.0
      ],
      [
        1016.6666870117188,
        1083.3333740234375,
        140.0
      ],
      [
        1016.6666870117188,
        966.6666870117188,
        140.0
      ],
      [
        1010.0,
        872.0369873046875,
        120.0
      ],
      [
        1010.0,
        886.1214599609375,
        120.0
      ],
      [
        1010.0,
        867.8524780273438,
        120.0
      ],
      [
        1010.0,
        872.0369873046875,
        120.0
      ],
      [
        1010.0,
        886.1214599609375,
        118.0
      ],
      [
        1010.0,
        872.0369873046875,
        118.0
      ],
      [
        1010.0,
        872.0369873046875,
        118.0
      ],
      [
        1010.0,
        867.8524780273438,
        118.0
      ],
      [
        1010.0,
        886.1214599609375,
        120.0
      ],
      [
        1010.0,
        886.1214599609375,
        118.0
      ],
      [
        1016.6666870117188,
        966.2667236328125,
        140.0
      ],
      [
        1016.6666870117188,
        1119.199951171875,
        140.0
      ],
      [
        1010.7999877929688,
        960.4000244140625,
        140.0
      ],
      [
        1010.7999877929688,
        930.7999877929688,
        140.0
      ],
      [
        1010.7999877929688,
        1119.199951171875,
        140.0
      ],
      [
        1010.7999877929688,
        1089.5999755859375,
        140.0
      ],
      [
        1010.7999877929688,
        960.4000244140625,
        140.0
      ],
      [
        1010.7999877929688,
        1119.199951171875,
        140.0
      ],
      [
        960.0,
        930.0,
        118.0
      ],
      [
        960.0,
        930.0,
        120.0
      ],
      [
        986.2361450195312,
        930.0,
        120.0
      ],
      [
        980.0,
        930.0,
        120.0
      ],
      [
        986.2120971679688,
        930.0,
        120.0
      ],
      [
        1000.0,
        930.0,
        120.0
      ],
      [
        960.0,
        930.0,
        120.0
      ],
      [
        980.0,
        930.0,
        120.0
      ],
      [
        1000.0,
        867.8524780273438,
        120.0
      ],
      [
        986.2361450195312,
        930.0,
        118.0
      ],
      [
        980.0,
        930.0,
        118.0
      ],
      [
        1000.0,
        930.0,
        118.0
      ],
      [
        986.2120971679688,
        930.0,
        118.0
      ],
      [
        980.0,
        930.0,
        118.0
      ],
      [
        960.0,
        930.0,
        118.0
      ],
      [
        1000.0,
        867.8524780273438,
        118.0
      ],
      [
        907.4263916015625,
        1083.890869140625,
        118.0
      ],
      [
        907.4263916015625,
        1083.890869140625,
        120.0
      ],
      [
        865.0,
        1100.0,
        120.0
      ],
      [
        865.0,
        1100.0,
        118.0
      ],
      [
        907.4263916015625,
        1006.109130859375,
        118.0
      ],
      [
        907.4263916015625,
        1006.109130859375,
        120.0
      ],
      [
        925.0,
        1045.0,
        120.0
      ],
      [
        925.0,
        1045.0,
        118.0
      ],
      [
        925.0,
        1045.0,
        118.0
      ],
      [
        925.0,
        1045.0,
        120.0
      ],
      [
        907.4263916015625,
        1083.890869140625,
        120.0
      ],
      [
        907.4263916015625,
        1083.890869140625,
        118.0
      ],
      [
        976.0,
        990.0,
        118.0
      ],
      [
        976.0,
        970.0,
        118.0
      ],
      [
        976.0,
        990.0,
        118.0
      ],
      [
        907.4263916015625,
        1083.890869140625,
        140.0
      ],
      [
        865.0,
        1100.0,
        140.0
      ],
      [
        925.0,
        1045.0,
        140.0
      ],
      [
        907.4263916015625,
        1083.890869140625,
        140.0
      ],
      [
        907.4263916015625,
        1006.109130859375,
        140.0
      ],
      [
        925.0,
        1045.0,
        140.0
      ],
      [
        780.0,
        1280.0,
        110.0
      ],
      [
        775.0,
        1280.0,
        110.0
      ],
      [
        1549.9998779296875,
        1550.0,
        370.0
      ],
      [
        1549.9998779296875,
        1550.0,
        500.0
      ],
      [
        1549.9998779296875,
        1550.0,
        370.0
      ],
      [
        1549.9998779296875,
        1550.0,
        140.0
      ],
      [
        1549.9998779296875,
        1550.0,
        500.0
      ],
      [
        1549.9998779296875,
        1550.0,
        1180.0
      ],
      [
        790.0,
        1580.0,
        160.0
      ],
      [
        970.0,
        1580.0,
        160.0
      ],
      [
        1039.49951171875,
        1630.0,
        160.0
      ],
      [
        1170.0,
        1630.0,
        160.0
      ],
      [
        1039.49951171875,
        1690.0,
        160.0
      ],
      [
        1039.49951171875,
        1630.0,
        160.0
      ],
      [
        970.0,
        1630.0,
        200.0
      ],
      [
        970.0,
        1680.0,
        160.0
      ],
      [
        970.0,
        1630.0,
        160.0
      ],
      [
        955.0,
        1655.0,
        160.0
      ],
      [
        970.0,
        1664.0,
        216.0
      ],
      [
        970.0,
        1664.0,
        160.0
      ],
      [
        980.0,
        1670.0,
        160.0
      ],
      [
        970.0,
        1580.0,
        160.0
      ],
      [
        945.0,
        1595.0,
        160.0
      ],
      [
        954.0,
        1580.0,
        216.0
      ],
      [
        954.0,
        1580.0,
        160.0
      ],
      [
        970.0,
        1580.0,
        216.0
      ],
      [
        980.0,
        1590.0,
        160.0
      ],
      [
        970.0,
        1580.0,
        160.0
      ],
      [
        960.0,
        1570.0,
        160.0
      ],
      [
        960.0,
        1570.0,
        160.0
      ],
      [
        1187.731689453125,
        1630.0,
        150.0
      ],
      [
        1037.5947265625,
        1630.0,
        150.0
      ],
      [
        1037.5947265625,
        1630.0,
        150.0
      ],
      [
        1037.5947265625,
        1690.0,
        150.0
      ],
      [
        970.0,
        1630.0,
        150.0
      ],
      [
        970.0,
        1630.0,
        160.0
      ],
      [
        955.0,
        1655.0,
        150.0
      ],
      [
        970.0,
        1664.0,
        160.0
      ],
      [
        970.0,
        1664.0,
        150.0
      ],
      [
        980.0,
        1670.0,
        150.0
      ],
      [
        945.0,
        1595.0,
        150.0
      ],
      [
        954.0,
        1580.0,
        160.0
      ],
      [
        954.0,
        1580.0,
        150.0
      ],
      [
        970.0,
        1580.0,
        160.0
      ],
      [
        980.0,
        1590.0,
        150.0
      ],
      [
        970.0,
        1580.0,
        150.0
      ],
      [
        950.0,
        1630.0,
        140.0
      ],
      [
        960.0,
        1630.0,
        150.0
      ],
      [
        955.0,
        1655.0,
        145.0000457763672
      ],
      [
        960.0,
        1658.0,
        150.0
      ],
      [
        945.0,
        1595.0,
        145.0
      ],
      [
        947.9999389648438,
        1590.0,
        150.0
      ],
      [
        954.0,
        1580.0,
        140.0
      ],
      [
        970.0,
        1580.0,
        140.0
      ],
      [
        1660.0,
        1469.9998779296875,
        370.0
      ],
      [
        1660.0,
        1469.9998779296875,
        500.0
      ],
      [
        1660.0,
        1469.9998779296875,
        370.0
      ],
      [
        1660.0,
        1469.9998779296875,
        140.0
      ],
      [
        1660.0,
        1469.9998779296875,
        500.0
      ],
      [
        1660.0,
        1469.9998779296875,
        1180.0
      ],
      [
        1750.0,
        1235.0,
        160.0
      ],
      [
        1750.0,
        1220.0,
        180.0
      ],
      [
        1750.0,
        1235.0,
        140.0
      ],
      [
        1750.0,
        1235.0,
        160.0
      ],
      [
        1710.0,
        1235.0,
        140.0
      ],
      [
        1700.0,
        1210.0,
        310.0
      ],
      [
        1700.0,
        1210.0,
        140.0
      ],
      [
        1700.0,
        1210.0,
        310.0
      ],
      [
        1350.0,
        1130.0,
        250.10211181640625
      ],
      [
        1350.0,
        1130.0,
        160.0
      ],
      [
        1475.0,
        1120.0,
        140.0
      ],
      [
        1475.0,
        1120.0,
        465.0
      ],
      [
        1555.0,
        1120.0,
        140.0
      ],
      [
        1555.0,
        1120.0,
        465.0
      ],
      [
        1395.0,
        1120.0,
        140.0
      ],
      [
        1395.0,
        1120.0,
        465.0
      ],
      [
        1350.0,
        1120.0,
        140.0
      ],
      [
        1350.0,
        1130.0,
        160.0
      ],
      [
        1240.0,
        1120.0,
        160.0
      ],
      [
        950.0,
        1120.0,
        140.0
      ],
      [
        950.0,
        1120.0,
        280.0
      ],
      [
        1000.0,
        1170.0,
        140.0
      ],
      [
        1000.0,
        1170.0,
        280.0
      ],
      [
        985.4664306640625,
        1170.0,
        280.0
      ],
      [
        950.0,
        1179.3992919921875,
        280.0
      ],
      [
        950.0,
        1179.3992919921875,
        400.0
      ],
      [
        985.4664306640625,
        1170.0,
        400.0
      ],
      [
        1030.0,
        1170.0,
        400.0
      ],
      [
        1030.0,
        1170.0,
        300.0
      ],
      [
        1000.0,
        1170.0,
        280.0
      ],
      [
        1030.0,
        1170.0,
        300.0
      ],
      [
        1001.373779296875,
        1170.0,
        280.9158630371094
      ],
      [
        950.0,
        950.0,
        140.0
      ],
      [
        950.0,
        950.0,
        220.0
      ],
      [
        1020.4000244140625,
        950.0,
        140.0
      ],
      [
        1020.3999633789062,
        970.0,
        140.0
      ],
      [
        1160.0,
        1109.5999755859375,
        140.0
      ],
      [
        1050.0,
        1109.5999755859375,
        140.0
      ],
      [
        1037.0,
        1092.0,
        580.0
      ],
      [
        1010.7999877929688,
        1109.5999755859375,
        140.0
      ],
      [
        1010.7999877929688,
        950.0,
        140.0
      ],
      [
        950.0,
        950.0,
        220.0
      ],
      [
        950.0,
        924.773681640625,
        337.72265625
      ],
      [
        868.6692504882812,
        1120.0,
        600.0
      ],
      [
        868.669189453125,
        1120.0,
        170.0
      ],
      [
        868.6692504882812,
        1120.0,
        170.0
      ],
      [
        865.0,
        1120.0,
        170.0
      ],
      [
        865.0,
        1120.0,
        170.0
      ],
      [
        861.330810546875,
        1120.0,
        170.0
      ],
      [
        1030.0,
        1520.0,
        370.0852355957031
      ],
      [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      [
        1050.0,
        1460.0,
        390.0852355957031
      ],
      [
        1030.0,
        1540.0,
        355.9431457519531
      ],
      [
        1030.0,
        1520.0,
        355.9431457519531
      ],
      [
        1030.0,
        1520.0,
        370.0852355957031
      ],
      [
        1030.0,
        1520.0,
        355.9431457519531
      ],
      [
        1030.0,
        1310.0,
        370.0852355957031
      ],
      [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      [
        1030.0,
        1330.0,
        370.0852355957031
      ],
      [
        1030.0,
        1330.0,
        355.9431457519531
      ],
      [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      [
        1030.0,
        1280.0,
        160.0
      ],
      [
        1030.0,
        1300.0,
        160.0
      ],
      [
        820.0,
        1310.0,
        160.08518981933594
      ],
      [
        799.9147338867188,
        1310.0,
        140.0
      ],
      [
        929.0144653320312,
        1520.0,
        180.0
      ],
      [
        929.0144653320312,
        1520.0,
        140.0
      ],
      [
        945.5584716796875,
        1310.0,
        160.0
      ],
      [
        490.0,
        1150.0,
        190.0
      ],
      [
        490.0,
        1130.0,
        190.0
      ],
      [
        490.0,
        1130.0,
        290.0
      ],
      [
        490.0,
        1150.0,
        290.0
      ],
      [
        490.0,
        1150.0,
        290.0
      ],
      [
        490.0,
        1130.0,
        290.0
      ],
      [
        480.0,
        1130.0,
        300.0
      ],
      [
        480.0,
        1150.0,
        300.0
      ],
      [
        490.0,
        1130.0,
        190.0
      ],
      [
        490.0,
        1150.0,
        190.0
      ],
      [
        480.0,
        1150.0,
        190.0
      ],
      [
        480.0,
        1130.0,
        190.0
      ],
      [
        480.0,
        1110.0,
        160.0
      ],
      [
        480.0,
        1110.0,
        190.0
      ],
      [
        480.0,
        1110.0,
        80.0
      ],
      [
        480.0,
        1110.0,
        120.0
      ],
      [
        480.0,
        1110.0,
        160.0
      ],
      [
        480.0,
        1090.0,
        160.0
      ],
      [
        480.0,
        980.0,
        300.0
      ],
      [
        480.0,
        1110.0,
        300.0
      ],
      [
        480.0,
        1090.0,
        120.0
      ],
      [
        480.0,
        1110.0,
        120.0
      ],
      [
        480.0,
        1090.0,
        160.0
      ],
      [
        480.0,
        1090.0,
        120.0
      ],
      [
        480.0,
        1110.0,
        190.0
      ],
      [
        490.0,
        1170.0,
        190.0
      ],
      [
        490.0,
        1170.0,
        290.0
      ],
      [
        480.0,
        1240.0,
        300.0
      ],
      [
        490.0,
        1170.0,
        290.0
      ],
      [
        480.0,
        1170.0,
        300.0
      ],
      [
        490.0,
        1170.0,
        190.0
      ],
      [
        480.0,
        1240.0,
        190.0
      ],
      [
        480.0,
        1170.0,
        190.0
      ],
      [
        440.0,
        1120.0,
        100.0
      ],
      [
        451.5,
        1110.0,
        98.99999237060547
      ],
      [
        451.5,
        1120.0,
        99.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        0.0,
        -2850.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1600.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        0.0,
        -2500.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1600.0,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        200.0,
        5034.5224609375,
        -33.027774810791016
      ],
      "bbox_max": [
        3108.39404296875,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        200.0,
        6871.484375,
        -22.699951171875
      ],
      "bbox_max": [
        3108.39404296875,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4461669921875,
      "bbox_min": [
        200.0,
        5034.5224609375,
        0.0
      ],
      "bbox_max": [
        3108.39404296875,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        816.3760375976562,
        6871.484375,
        547.115966796875
      ],
      "bbox_max": [
        3108.39404296875,
        7327.39501953125,
        652.46484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        200.0,
        6871.484375,
        623.0784912109375
      ],
      "bbox_max": [
        3108.39404296875,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1689.9998779296875,
      "bbox_min": [
        290.0,
        500.0,
        60.0
      ],
      "bbox_max": [
        2091.7158203125,
        1690.0,
        1180.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1769.9998779296875,
      "bbox_min": [
        290.0,
        500.0,
        60.0
      ],
      "bbox_max": [
        2091.7158203125,
        1690.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1910.0,
        1470.0,
        500.0
      ],
      "bbox_max": [
        2091.7158203125,
        1579.9000244140625,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1910.0,
        1470.0,
        500.0
      ],
      "bbox_max": [
        1910.0,
        1579.9000244140625,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.7808688282966614,
        -0.0
      ],
      "plane_d": -1118.2041015625,
      "bbox_min": [
        990.0,
        500.0,
        120.0
      ],
      "bbox_max": [
        1060.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1060.0,
        500.0,
        220.0
      ],
      "bbox_max": [
        1060.0,
        584.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        1040.0,
        584.0,
        120.0
      ],
      "bbox_max": [
        1060.0,
        600.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1060.0,
        584.0,
        220.0
      ],
      "bbox_max": [
        1060.0,
        600.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        290.0,
        700.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        760.0,
        700.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        760.0,
        700.0,
        60.0
      ],
      "bbox_max": [
        1014.2000122070312,
        867.8525390625,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        866.452880859375,
        720.11572265625,
        118.0
      ],
      "bbox_max": [
        1014.2000122070312,
        867.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        866.452880859375,
        720.11572265625,
        120.0
      ],
      "bbox_max": [
        1014.2000122070312,
        867.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        760.0,
        700.0,
        60.0
      ],
      "bbox_max": [
        1014.1600952148438,
        867.8525390625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        830.0,
        700.0,
        60.0
      ],
      "bbox_max": [
        1014.1600952148438,
        867.8525390625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        922.1474609375,
        830.0,
        80.0
      ],
      "bbox_max": [
        997.8525390625,
        867.8525390625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        866.452880859375,
        720.1453857421875,
        118.0
      ],
      "bbox_max": [
        1014.1599731445312,
        867.8525390625,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        866.452880859375,
        720.1453857421875,
        118.0
      ],
      "bbox_max": [
        1014.1599731445312,
        867.8525390625,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 21.21319580078125,
      "bbox_min": [
        886.0660400390625,
        856.0660400390625,
        118.0
      ],
      "bbox_max": [
        980.0,
        867.8525390625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        980.0,
        862.0322265625,
        118.0
      ],
      "bbox_max": [
        980.0,
        867.8525390625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        760.0,
        867.8524780273438,
        60.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        1180.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1629.9998779296875,
      "bbox_min": [
        760.0,
        867.8524780273438,
        60.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1630.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1630.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1670.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2938015743202413e-06,
        -0.7071091532707214,
        0.7071043252944946
      ],
      "plane_d": 940.4536743164062,
      "bbox_min": [
        1630.0,
        1468.0,
        138.0
      ],
      "bbox_max": [
        1655.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2938015743202413e-06,
        -0.7071091532707214,
        0.7071043252944946
      ],
      "plane_d": 940.4536743164062,
      "bbox_min": [
        1630.0,
        1450.0001220703125,
        120.0
      ],
      "bbox_max": [
        1655.0001220703125,
        1468.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1630.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1450.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1630.0,
        995.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1210.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1630.0,
        995.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        1210.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1630.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1633.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        1657.0,
        1050.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1200.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 804.3154296875,
      "bbox_min": [
        1657.0,
        1140.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1657.0,
        1140.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1140.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 804.3154296875,
      "bbox_min": [
        1630.0,
        1140.0,
        120.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1630.0,
        1140.0,
        120.0
      ],
      "bbox_max": [
        1660.0,
        1140.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1630.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1170.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        1680.0,
        995.0,
        80.0
      ],
      "bbox_max": [
        1710.0,
        1220.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 346.48236083984375,
      "bbox_min": [
        1690.0,
        1200.0,
        120.0
      ],
      "bbox_max": [
        1710.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8921462297439575,
        -0.07137169688940048,
        0.44607311487197876
      ],
      "plane_d": 1534.1346435546875,
      "bbox_min": [
        1680.0,
        995.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1200.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        0.44721361994743347
      ],
      "plane_d": 1457.91650390625,
      "bbox_min": [
        1680.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1690.0,
        1200.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        760.0,
        867.8524780273438,
        60.0
      ],
      "bbox_max": [
        1630.0,
        1690.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1250.0,
        1110.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1480.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 997.0205688476562,
      "bbox_min": [
        1480.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1530.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1690.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.500001847743988,
        -0.500001847743988,
        0.7071040868759155
      ],
      "plane_d": 1430.153076171875,
      "bbox_min": [
        1547.9998779296875,
        1467.9998779296875,
        138.0
      ],
      "bbox_max": [
        1630.0,
        1508.2841796875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2938015743202413e-06,
        -0.7071091532707214,
        0.7071043252944946
      ],
      "plane_d": 940.4536743164062,
      "bbox_min": [
        1587.455810546875,
        1467.9998779296875,
        138.0
      ],
      "bbox_max": [
        1630.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1530.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1507.455810546875,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2938015743202413e-06,
        -0.7071091532707214,
        0.7071043252944946
      ],
      "plane_d": 940.4536743164062,
      "bbox_min": [
        1580.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1468.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1480.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1548.0,
        1684.999755859375,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        1530.0,
        1450.0,
        138.0
      ],
      "bbox_max": [
        1530.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1480.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1530.0,
        1500.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1480.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1480.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1480.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1530.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1450.0,
        124.99991607666016
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 812.1399536132812,
      "bbox_min": [
        1570.0001220703125,
        1440.0,
        120.0
      ],
      "bbox_max": [
        1576.0,
        1445.9998779296875,
        122.99993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1480.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1170.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1480.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1170.0,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1480.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1617.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 798.7683715820312,
      "bbox_min": [
        1617.0,
        1160.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1160.0,
      "bbox_min": [
        1617.0,
        1160.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        1160.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 798.7683715820312,
      "bbox_min": [
        1590.0,
        1160.0,
        100.0
      ],
      "bbox_max": [
        1620.0,
        1170.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1160.0,
      "bbox_min": [
        1590.0,
        1160.0,
        100.0
      ],
      "bbox_max": [
        1620.0,
        1160.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1480.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1615.0,
        1170.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1554.9998779296875,
      "bbox_min": [
        1535.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1555.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        1535.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1535.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1554.9998779296875,
      "bbox_min": [
        1555.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1555.0,
        1128.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1535.0,
        1128.0,
        138.0
      ],
      "bbox_max": [
        1555.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        1535.0,
        1128.0,
        138.0
      ],
      "bbox_max": [
        1535.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1480.0,
        1350.0,
        115.65217590332031
      ],
      "bbox_max": [
        1580.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04339630529284477,
        -0.04339630529284477,
        0.9981150031089783
      ],
      "plane_d": 7.377372741699219,
      "bbox_min": [
        1480.0,
        1350.0,
        115.65217590332031
      ],
      "bbox_max": [
        1530.0,
        1450.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1480.0,
        1380.0,
        120.0
      ],
      "bbox_max": [
        1576.0,
        1450.0,
        140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        1530.0,
        1440.0,
        138.0
      ],
      "bbox_max": [
        1544.0,
        1450.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        1530.0,
        1440.0,
        138.0
      ],
      "bbox_max": [
        1530.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 812.1399536132812,
      "bbox_min": [
        1540.0,
        1440.0,
        120.0
      ],
      "bbox_max": [
        1576.0,
        1450.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1439.9998779296875,
      "bbox_min": [
        1540.0,
        1440.0,
        122.99993896484375
      ],
      "bbox_max": [
        1570.0001220703125,
        1440.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1170.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1170.0,
        140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1170.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1270.0001220703125,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        1170.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 491.9349670410156,
      "bbox_min": [
        1336.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1350.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1150.0,
      "bbox_min": [
        1336.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1350.0,
        1170.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1159.9998779296875,
      "bbox_min": [
        1346.0,
        1160.0,
        118.0
      ],
      "bbox_max": [
        1350.0,
        1160.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1350.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1350.0,
        1150.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 491.9349670410156,
      "bbox_min": [
        1300.0,
        1150.0,
        100.0
      ],
      "bbox_max": [
        1340.0,
        1160.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1149.9998779296875,
      "bbox_min": [
        1300.0,
        1150.0,
        100.0
      ],
      "bbox_max": [
        1340.0,
        1150.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1290.0,
        1120.0,
        120.0
      ],
      "bbox_max": [
        1480.0,
        1170.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1455.0,
      "bbox_min": [
        1395.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1475.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1474.9998779296875,
      "bbox_min": [
        1475.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1475.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1394.9998779296875,
      "bbox_min": [
        1395.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1395.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1394.9998779296875,
      "bbox_min": [
        1395.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1475.0,
        1128.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1290.0,
        1128.0,
        120.0
      ],
      "bbox_max": [
        1475.0,
        1170.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1160.0,
      "bbox_min": [
        1290.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1314.0,
        1160.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        -0.0,
        -0.8944272398948669
      ],
      "plane_d": 709.2808227539062,
      "bbox_min": [
        1310.0,
        1160.0,
        120.0
      ],
      "bbox_max": [
        1350.0,
        1170.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1159.9998779296875,
      "bbox_min": [
        1310.0,
        1160.0,
        120.0
      ],
      "bbox_max": [
        1350.0,
        1160.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04339630529284477,
        -0.04339630529284477,
        0.9981150031089783
      ],
      "plane_d": 7.377372741699219,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 42.4263916015625,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1428.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1420.0,
        140.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1814.335693359375,
      "bbox_min": [
        1280.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1347.928955078125,
        1232.928955078125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1160.0,
      "bbox_min": [
        1280.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1290.0,
        1160.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1300.0,
        1205.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1250.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1270.0001220703125,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1250.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1270.0001220703125,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1250.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1270.0001220703125,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1250.0,
        1190.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1428.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1297.928955078125,
        1252.9288330078125,
        138.0
      ],
      "bbox_max": [
        1480.0,
        1428.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9996317028999329,
        0.027140598744153976,
        0.0
      ],
      "plane_d": 1440.6982421875,
      "bbox_min": [
        1479.7767333984375,
        1419.7767333984375,
        138.0
      ],
      "bbox_max": [
        1480.0,
        1428.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -1046.4798583984375,
      "bbox_min": [
        1380.0,
        1110.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1395.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1120.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        1395.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1474.9998779296875,
      "bbox_min": [
        1395.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1555.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1535.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1555.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1554.9998779296875,
      "bbox_min": [
        1535.0,
        1110.0,
        138.0
      ],
      "bbox_max": [
        1555.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        1535.0,
        1110.0,
        138.0
      ],
      "bbox_max": [
        1535.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1554.9998779296875,
      "bbox_min": [
        1555.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1555.0,
        1120.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1395.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1475.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1394.9998779296875,
      "bbox_min": [
        1395.0,
        1110.0,
        138.0
      ],
      "bbox_max": [
        1455.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1455.0,
      "bbox_min": [
        1455.0,
        1110.0,
        138.0
      ],
      "bbox_max": [
        1455.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1394.9998779296875,
      "bbox_min": [
        1395.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1395.0,
        1120.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        760.0,
        867.8524780273438,
        60.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        780.0,
        1460.0,
        60.0
      ],
      "bbox_max": [
        1225.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        780.0,
        1460.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        780.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        820.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        940.0,
        1610.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        955.0,
        1655.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        945.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1595.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 431.3350830078125,
      "bbox_min": [
        960.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1590.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.09950371831655502,
        0.0,
        0.9950371980667114
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        780.0,
        1460.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        890.0,
        1472.83544921875,
        71.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        76.55584716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        890.0,
        1460.0,
        89.1501693725586
      ],
      "bbox_max": [
        980.0,
        1570.0,
        105.48612976074219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        945.5584716796875,
        1540.0,
        100.0
      ],
      "bbox_max": [
        958.1143188476562,
        1570.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        890.0,
        1460.0,
        89.1501693725586
      ],
      "bbox_max": [
        980.0,
        1555.1787109375,
        105.48612976074219
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        890.0,
        1460.0,
        89.1501693725586
      ],
      "bbox_max": [
        945.5585327148438,
        1540.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1460.0,
        89.1501693725586
      ],
      "bbox_max": [
        890.0,
        1472.83544921875,
        91.15017700195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        960.0,
        1550.0,
        100.30035400390625
      ],
      "bbox_max": [
        980.0,
        1550.0,
        105.48612976074219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        890.0,
        1460.0,
        71.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        103.48612213134766
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        958.1143188476562,
        1460.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        103.48612213134766
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        960.0,
        1550.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        960.0,
        1550.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        103.48612213134766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        890.0,
        1460.0,
        71.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1460.0,
        71.0
      ],
      "bbox_max": [
        890.0,
        1472.83544921875,
        89.1501693725586
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        820.0,
        1460.0,
        91.15017700195312
      ],
      "bbox_max": [
        980.0,
        1570.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        890.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -945.5584716796875,
      "bbox_min": [
        945.5584716796875,
        1540.0,
        120.0
      ],
      "bbox_max": [
        945.5584716796875,
        1570.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        890.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        890.0,
        1472.83544921875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        890.0,
        1460.0,
        91.15017700195312
      ],
      "bbox_max": [
        980.0,
        1550.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        890.0,
        1460.0,
        91.15017700195312
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        890.0,
        1460.0,
        91.15017700195312
      ],
      "bbox_max": [
        933.0026245117188,
        1524.8212890625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1460.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1472.83544921875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1460.0,
        91.15017700195312
      ],
      "bbox_max": [
        890.0,
        1472.83544921875,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        890.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        890.0,
        1472.83544921875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        980.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        1225.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        980.0,
        1590.0,
        80.0
      ],
      "bbox_max": [
        1225.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        980.0,
        1590.0,
        80.0
      ],
      "bbox_max": [
        1225.0,
        1690.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05225301533937454,
        -0.8944270610809326,
        0.4441506266593933
      ],
      "plane_d": 1458.3773193359375,
      "bbox_min": [
        1020.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1183.0,
        1620.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1020.0,
      "bbox_min": [
        1020.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47058823704719543,
        0.0,
        0.8823529481887817
      ],
      "plane_d": 382.3529357910156,
      "bbox_min": [
        1033.75,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1033.75,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1037.5,
        1610.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        980.0,
        1590.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        980.0,
        1590.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05225301533937454,
        -0.8944270610809326,
        0.4441506266593933
      ],
      "plane_d": 1458.3773193359375,
      "bbox_min": [
        980.0,
        1620.0,
        80.0
      ],
      "bbox_max": [
        1183.0,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        980.0,
        1620.0,
        80.0
      ],
      "bbox_max": [
        1036.5,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        980.0,
        1620.0,
        80.0
      ],
      "bbox_max": [
        1036.5,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9405532479286194,
        0.0,
        0.3396463692188263
      ],
      "plane_d": 934.80517578125,
      "bbox_min": [
        1030.0,
        1620.0,
        100.0
      ],
      "bbox_max": [
        1036.5,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        980.0,
        1620.7593994140625,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        1620.7593994140625,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1640.0,
      "bbox_min": [
        1000.0,
        1620.7593994140625,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        1620.7593994140625,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        980.0,
        1620.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1622.9208984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        1620.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1621.927734375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        1620.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1621.7525634765625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        980.0,
        1590.0,
        80.0
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47058823704719543,
        0.0,
        -0.8823529481887817
      ],
      "plane_d": -384.1176452636719,
      "bbox_min": [
        980.0,
        1590.0,
        98.0
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        980.0,
        1590.0,
        98.0
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        996.25,
        1610.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1620.0,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        980.0,
        1610.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1620.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        980.0,
        1590.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1610.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        1590.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1610.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        1590.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1610.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05225301533937454,
        -0.8944270610809326,
        0.4441506266593933
      ],
      "plane_d": 1458.3773193359375,
      "bbox_min": [
        1037.2222900390625,
        1620.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.5947265625,
      "bbox_min": [
        1037.5947265625,
        1630.0,
        121.03141784667969
      ],
      "bbox_max": [
        1037.5947265625,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1037.5947265625,
        1630.0,
        121.03141784667969
      ],
      "bbox_max": [
        1187.731689453125,
        1639.419189453125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.5947265625,
      "bbox_min": [
        1037.5947265625,
        1630.0,
        121.03141784667969
      ],
      "bbox_max": [
        1037.5947265625,
        1639.419189453125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        980.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1590.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1590.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1460.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        980.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1590.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.09950372576713562,
        0.0,
        0.9950372576713562
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        780.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.11684099584817886,
        0.0,
        0.9931507110595703
      ],
      "plane_d": 40.8941650390625,
      "bbox_min": [
        980.0,
        1420.0,
        80.0
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        87.05882263183594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        980.0,
        1420.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1460.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        820.0,
        1420.0,
        64.0
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        820.0,
        1420.0,
        64.0
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1450.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        1000.0,
        1420.0,
        98.0
      ],
      "bbox_max": [
        1070.0,
        1440.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        1420.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1440.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1420.0,
        64.0
      ],
      "bbox_max": [
        890.0,
        1460.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1450.0,
        71.0
      ],
      "bbox_max": [
        890.0,
        1460.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1450.0,
        100.0
      ],
      "bbox_max": [
        890.0,
        1460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1450.0,
        100.0
      ],
      "bbox_max": [
        890.0,
        1460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        760.0,
        867.8524780273438,
        60.0
      ],
      "bbox_max": [
        1250.0,
        1420.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1030.0,
        867.8524780273438,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1420.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1030.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1420.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1030.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1420.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684099584817886,
        0.0,
        0.9931507110595703
      ],
      "plane_d": 40.8941650390625,
      "bbox_min": [
        1030.0,
        1390.0,
        80.0
      ],
      "bbox_max": [
        1090.0,
        1420.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1030.0,
        1390.0,
        98.0
      ],
      "bbox_max": [
        1090.0,
        1410.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1030.0,
        1390.0,
        98.0
      ],
      "bbox_max": [
        1090.0,
        1410.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1030.0,
        1390.0,
        98.0
      ],
      "bbox_max": [
        1090.0,
        1410.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1200.0,
        1170.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1220.0,
      "bbox_min": [
        1240.0,
        1220.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1215.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1226.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1226.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1200.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        1030.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1200.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1030.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1030.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1030.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1100.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        1100.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1100.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10468478500843048,
        0.9945054650306702
      ],
      "plane_d": 17.796409606933594,
      "bbox_min": [
        1030.0,
        867.8524780273438,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1030.0,
        867.8524780273438,
        80.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8395703434944153,
        0.5432510375976562
      ],
      "plane_d": -782.281982421875,
      "bbox_min": [
        1030.0,
        867.8524780273438,
        80.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": -1114.3089599609375,
      "bbox_min": [
        1030.0,
        867.8524780273438,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1030.0,
        867.8524780273438,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1110.4801025390625,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1030.0,
        867.8524780273438,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1110.4801025390625,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -887.8524780273438,
      "bbox_min": [
        1030.0,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1110.4801025390625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1095.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1110.4801025390625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1050.0,
        1109.199951171875,
        130.0
      ],
      "bbox_max": [
        1160.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1159.5999755859375,
        1109.199951171875,
        130.0
      ],
      "bbox_max": [
        1160.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320502638816833,
        0.5547001957893372
      ],
      "plane_d": -1004.00732421875,
      "bbox_min": [
        1030.0,
        1109.5999755859375,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1040.0,
        1109.5999755859375,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        1110.4000244140625,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1110.4000244140625,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1040.0,
        1109.5999755859375,
        130.0
      ],
      "bbox_max": [
        1170.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1040.0,
        1109.5999755859375,
        130.0
      ],
      "bbox_max": [
        1050.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": -1126.7999267578125,
      "bbox_min": [
        1030.0,
        1113.3333740234375,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1163.7333984375,
        1113.3333740234375,
        130.0
      ],
      "bbox_max": [
        1170.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        780.0,
        867.8524780273438,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1420.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        780.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1420.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1279.9998779296875,
      "bbox_min": [
        780.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1420.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        780.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1170.0,
        133.9837646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        -0.371390700340271,
        0.0
      ],
      "plane_d": -475.3800964355469,
      "bbox_min": [
        960.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1170.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        960.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1170.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8237894773483276,
        -0.29381439089775085,
        -0.48481348156929016
      ],
      "plane_d": -413.284423828125,
      "bbox_min": [
        960.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        970.0,
        1131.537109375,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8237894773483276,
        -0.29381439089775085,
        -0.48481348156929016
      ],
      "plane_d": -413.284423828125,
      "bbox_min": [
        965.8851928710938,
        1120.0,
        110.0
      ],
      "bbox_max": [
        980.0,
        1156.537109375,
        133.9837646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8304547071456909,
        -0.3321818709373474,
        -0.4472138285636902
      ],
      "plane_d": -380.4714660644531,
      "bbox_min": [
        970.0,
        1131.537109375,
        110.0
      ],
      "bbox_max": [
        980.0,
        1156.537109375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09950372576713562,
        0.0,
        0.9950372576713562
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        780.0,
        1280.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1420.0,
        140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        820.0,
        1310.0,
        64.0
      ],
      "bbox_max": [
        945.5584716796875,
        1377.16455078125,
        76.55585479736328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        0.6373907923698425,
        -0.0
      ],
      "plane_d": -1563.5732421875,
      "bbox_min": [
        890.0,
        1310.0,
        71.0
      ],
      "bbox_max": [
        945.5584716796875,
        1377.16455078125,
        76.55585479736328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        780.0,
        1310.0,
        61.0
      ],
      "bbox_max": [
        980.0,
        1420.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -790.0,
      "bbox_min": [
        790.0,
        1310.0,
        98.0
      ],
      "bbox_max": [
        790.0,
        1320.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        883.0,
        1377.16455078125,
        98.0
      ],
      "bbox_max": [
        890.0,
        1404.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1404.0,
      "bbox_min": [
        883.0,
        1404.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1404.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        0.6373907923698425,
        -0.0
      ],
      "plane_d": -1563.5732421875,
      "bbox_min": [
        790.0,
        1310.0,
        61.0
      ],
      "bbox_max": [
        945.5584716796875,
        1420.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2747211158275604,
        0.0,
        -0.9615239500999451
      ],
      "plane_d": -150.27244567871094,
      "bbox_min": [
        820.0,
        1404.0,
        78.0
      ],
      "bbox_max": [
        867.8016357421875,
        1420.0,
        91.6576156616211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -790.0,
      "bbox_min": [
        790.0,
        1310.0,
        61.0
      ],
      "bbox_max": [
        790.0,
        1320.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2747211158275604,
        0.0,
        -0.9615239500999451
      ],
      "plane_d": -150.27244567871094,
      "bbox_min": [
        854.5664672851562,
        1377.16455078125,
        71.0
      ],
      "bbox_max": [
        890.0,
        1420.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1404.0,
      "bbox_min": [
        867.8016357421875,
        1404.0,
        91.6576156616211
      ],
      "bbox_max": [
        890.0,
        1404.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1377.16455078125,
        71.0
      ],
      "bbox_max": [
        890.0,
        1400.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        780.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        945.5584716796875,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        0.6373907923698425,
        -0.0
      ],
      "plane_d": -1563.5732421875,
      "bbox_min": [
        890.0,
        1310.0,
        120.0
      ],
      "bbox_max": [
        945.5584716796875,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1377.16455078125,
        120.0
      ],
      "bbox_max": [
        890.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        0.6373907923698425,
        -0.0
      ],
      "plane_d": -1563.5732421875,
      "bbox_min": [
        790.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        945.5584716796875,
        1400.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -790.0,
      "bbox_min": [
        790.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        790.0,
        1320.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1377.16455078125,
        100.0
      ],
      "bbox_max": [
        890.0,
        1400.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15730521082878113,
        0.0,
        -0.9875500798225403
      ],
      "plane_d": -51.96137237548828,
      "bbox_min": [
        820.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1310.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        820.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1310.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -945.5584716796875,
      "bbox_min": [
        945.5584716796875,
        1280.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1310.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        960.0,
        1300.0,
        120.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        945.5584716796875,
        1280.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1310.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        960.0,
        1300.0,
        100.30036163330078
      ],
      "bbox_max": [
        980.0,
        1300.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        945.5584716796875,
        1280.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1310.0,
        103.48612976074219
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        958.1143188476562,
        1280.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1310.0,
        103.48612976074219
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        960.0,
        1300.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        960.0,
        1300.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        103.48612976074219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        960.0,
        1300.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        980.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1420.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8237894773483276,
        -0.29381439089775085,
        -0.48481348156929016
      ],
      "plane_d": -413.284423828125,
      "bbox_min": [
        980.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1000.0,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1279.9998779296875,
      "bbox_min": [
        980.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        1000.0,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        980.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        990.0,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        980.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        990.0,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        980.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        990.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        980.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1420.0,
        120.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1020.0,
      "bbox_min": [
        980.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1420.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        980.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1020.0,
        1420.0,
        100.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        980.0,
        1120.0,
        98.0
      ],
      "bbox_max": [
        1020.0,
        1420.0,
        100.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1000.0,
        1140.0,
        98.0
      ],
      "bbox_max": [
        1020.0,
        1140.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 532.1842041015625,
      "bbox_min": [
        1000.0,
        1386.0,
        98.0
      ],
      "bbox_max": [
        1020.0,
        1390.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1010.0,
        1386.0,
        98.0
      ],
      "bbox_max": [
        1020.0,
        1390.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1009.9999389648438,
      "bbox_min": [
        1010.0,
        1386.0,
        98.0
      ],
      "bbox_max": [
        1010.0,
        1390.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1280.0,
      "bbox_min": [
        980.0,
        1160.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1280.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        980.0,
        1160.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1160.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 532.1842041015625,
      "bbox_min": [
        1000.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1020.0,
        1390.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 999.9999389648438,
      "bbox_min": [
        1000.0,
        1350.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1390.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1009.9999389648438,
      "bbox_min": [
        1010.0,
        1350.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1390.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10459312796592712,
        0.04183724895119667,
        0.9936347007751465
      ],
      "plane_d": -20.709434509277344,
      "bbox_min": [
        1010.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1020.0,
        1145.0,
        81.05262756347656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10459312796592712,
        0.04183724895119667,
        0.9936347007751465
      ],
      "plane_d": -20.709434509277344,
      "bbox_min": [
        1020.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1410.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1020.0,
        1246.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1410.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 646.6708984375,
      "bbox_min": [
        1020.0,
        1246.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1390.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1020.0,
        1260.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1390.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1260.0,
      "bbox_min": [
        1020.0,
        1260.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1260.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -648.4597778320312,
      "bbox_min": [
        988.9999389648438,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1019.9999389648438,
      "bbox_min": [
        988.9999389648438,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1250.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1020.0,
        1206.0,
        120.0
      ],
      "bbox_max": [
        1030.0,
        1210.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1020.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1210.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1020.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1206.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        1020.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1200.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1020.0000610351562,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        988.9999389648438,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1020.0000610351562,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        988.9999389648438,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1020.0000610351562,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        988.9999389648438,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1020.0000610351562,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        780.0,
        867.8524780273438,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1120.0,
        140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        780.0,
        867.8525390625,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1120.0,
        110.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": 26.50357437133789,
      "bbox_min": [
        780.0,
        867.8525390625,
        60.0
      ],
      "bbox_max": [
        1010.0,
        1120.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        997.8525390625,
        867.8525390625,
        78.65028381347656
      ],
      "bbox_max": [
        1010.0,
        880.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        867.8525390625,
        60.0
      ],
      "bbox_max": [
        960.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07647190988063812,
        -0.07647190988063812,
        0.9941348433494568
      ],
      "plane_d": 57.35393142700195,
      "bbox_min": [
        904.6011352539062,
        867.8525390625,
        78.65028381347656
      ],
      "bbox_max": [
        922.1474609375,
        880.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        950.0,
        970.0,
        78.88890075683594
      ],
      "bbox_max": [
        950.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        780.0,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8395703434944153,
        0.5432510375976562
      ],
      "plane_d": -782.281982421875,
      "bbox_min": [
        1010.0,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1030.0,
        880.0,
        98.77336120605469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        1010.0,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1014.1600952148438,
        880.0,
        98.77336120605469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1120.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        998.9463500976562,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1010.0,
        880.0,
        93.6399154663086
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        860.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -860.0,
      "bbox_min": [
        860.0,
        930.0,
        108.0
      ],
      "bbox_max": [
        860.0,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        950.0,
        970.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        110.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        950.0,
        970.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        110.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 579.5888671875,
      "bbox_min": [
        950.0,
        1096.0,
        98.0
      ],
      "bbox_max": [
        960.0,
        1100.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -959.9999389648438,
      "bbox_min": [
        960.0,
        1096.0,
        98.0
      ],
      "bbox_max": [
        960.0,
        1100.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -581.377685546875,
      "bbox_min": [
        950.0,
        970.0,
        100.0
      ],
      "bbox_max": [
        964.0,
        1100.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 108.0,
      "bbox_min": [
        950.0,
        970.0,
        100.0
      ],
      "bbox_max": [
        964.0,
        1100.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -332.7269287109375,
      "bbox_min": [
        950.0,
        970.0,
        108.0
      ],
      "bbox_max": [
        964.0,
        1084.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        950.0,
        990.0,
        108.0
      ],
      "bbox_max": [
        964.0,
        1084.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -990.0,
      "bbox_min": [
        950.0,
        990.0,
        108.0
      ],
      "bbox_max": [
        960.0,
        990.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -989.9999389648438,
      "bbox_min": [
        960.0,
        990.0,
        108.0
      ],
      "bbox_max": [
        964.0,
        990.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 579.5888671875,
      "bbox_min": [
        950.0,
        1080.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        1100.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -959.9999389648438,
      "bbox_min": [
        960.0,
        1080.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        1100.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        780.0,
        867.8524780273438,
        110.0
      ],
      "bbox_max": [
        1030.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1010.0,
        867.8524780273438,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1019.5199584960938,
        867.8524780273438,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1019.5199584960938,
        867.8524780273438,
        118.0
      ],
      "bbox_max": [
        1030.0,
        887.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -887.8524780273438,
      "bbox_min": [
        1019.5199584960938,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1030.0,
        887.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": -1114.3089599609375,
      "bbox_min": [
        1020.0,
        970.0,
        130.0
      ],
      "bbox_max": [
        1030.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1020.0,
        970.0,
        130.0
      ],
      "bbox_max": [
        1020.7999877929688,
        970.4000244140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968152642250061,
        0.07974521815776825
      ],
      "plane_d": -1126.7999267578125,
      "bbox_min": [
        1020.0,
        1119.199951171875,
        130.0
      ],
      "bbox_max": [
        1030.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1010.0,
        867.8524780273438,
        118.0
      ],
      "bbox_max": [
        1020.3999633789062,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1010.0,
        867.8524780273438,
        118.0
      ],
      "bbox_max": [
        1020.3999633789062,
        1120.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1010.0,
        867.8524780273438,
        118.0
      ],
      "bbox_max": [
        1019.5999755859375,
        887.8524780273438,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -887.8524780273438,
      "bbox_min": [
        1010.0,
        886.1214599609375,
        118.0
      ],
      "bbox_max": [
        1019.5999755859375,
        887.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.381051242351532,
        0.9245539903640747,
        0.0
      ],
      "plane_d": -434.4053649902344,
      "bbox_min": [
        1010.0,
        886.1214599609375,
        118.0
      ],
      "bbox_max": [
        1014.2000122070312,
        887.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1010.0,
        960.0,
        130.0
      ],
      "bbox_max": [
        1020.3999633789062,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968152642250061,
        0.07974521815776825
      ],
      "plane_d": -1126.7999267578125,
      "bbox_min": [
        1010.0,
        1119.199951171875,
        130.0
      ],
      "bbox_max": [
        1020.3999633789062,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1016.6666870117188,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1010.0,
        960.0,
        130.0
      ],
      "bbox_max": [
        1016.6666870117188,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968152642250061,
        0.07974521815776825
      ],
      "plane_d": -1126.7999267578125,
      "bbox_min": [
        1010.0,
        1119.199951171875,
        130.0
      ],
      "bbox_max": [
        1016.6666870117188,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        780.0,
        867.8524780273438,
        110.0
      ],
      "bbox_max": [
        1010.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        867.8524780273438,
        110.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 21.21319580078125,
      "bbox_min": [
        897.8525390625,
        867.8524780273438,
        118.0
      ],
      "bbox_max": [
        1000.0,
        930.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        897.8525390625,
        867.8524780273438,
        118.0
      ],
      "bbox_max": [
        1000.0,
        930.0,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        897.8525390625,
        867.8524780273438,
        118.0
      ],
      "bbox_max": [
        1000.0,
        930.0,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        980.0,
        867.8525390625,
        118.0
      ],
      "bbox_max": [
        980.0,
        921.7156982421875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        865.0,
        930.0,
        110.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        865.0,
        930.0,
        110.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        865.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1120.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        -0.0
      ],
      "plane_d": -1335.414306640625,
      "bbox_min": [
        865.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1100.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112828373908997,
        -0.4117811918258667,
        0.0
      ],
      "plane_d": -412.62530517578125,
      "bbox_min": [
        907.4263916015625,
        930.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1083.890869140625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112828373908997,
        0.4117811918258667,
        -0.0
      ],
      "plane_d": -1273.248046875,
      "bbox_min": [
        907.4263916015625,
        1045.0,
        118.0
      ],
      "bbox_max": [
        925.0,
        1083.890869140625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 21.21319580078125,
      "bbox_min": [
        960.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        990.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 330.9380798339844,
      "bbox_min": [
        976.0,
        970.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        990.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -989.9999389648438,
      "bbox_min": [
        976.0,
        990.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        990.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        -0.0
      ],
      "plane_d": -1335.414306640625,
      "bbox_min": [
        865.0,
        970.0,
        110.0
      ],
      "bbox_max": [
        980.0,
        1100.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112828373908997,
        0.4117811918258667,
        -0.0
      ],
      "plane_d": -1273.248046875,
      "bbox_min": [
        907.4263916015625,
        970.0,
        110.0
      ],
      "bbox_max": [
        980.0,
        1083.890869140625,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112828373908997,
        -0.4117811918258667,
        0.0
      ],
      "plane_d": -412.62530517578125,
      "bbox_min": [
        907.4263916015625,
        1006.109130859375,
        110.0
      ],
      "bbox_max": [
        925.0,
        1045.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -332.7269287109375,
      "bbox_min": [
        960.0,
        970.0,
        110.0
      ],
      "bbox_max": [
        980.0,
        990.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 330.9380798339844,
      "bbox_min": [
        960.0,
        970.0,
        110.0
      ],
      "bbox_max": [
        980.0,
        990.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -989.9999389648438,
      "bbox_min": [
        960.0,
        990.0,
        110.0
      ],
      "bbox_max": [
        980.0,
        990.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        -0.0
      ],
      "plane_d": -1335.414306640625,
      "bbox_min": [
        865.0,
        1006.109130859375,
        120.0
      ],
      "bbox_max": [
        925.0,
        1100.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112828373908997,
        0.4117811918258667,
        -0.0
      ],
      "plane_d": -1273.248046875,
      "bbox_min": [
        907.4263916015625,
        1006.109130859375,
        120.0
      ],
      "bbox_max": [
        925.0,
        1083.890869140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112828373908997,
        -0.4117811918258667,
        0.0
      ],
      "plane_d": -412.62530517578125,
      "bbox_min": [
        907.4263916015625,
        1006.109130859375,
        120.0
      ],
      "bbox_max": [
        925.0,
        1045.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1000.0,
        867.8524780273438,
        118.0
      ],
      "bbox_max": [
        1010.0,
        886.1214599609375,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1000.0,
        867.8524780273438,
        118.0
      ],
      "bbox_max": [
        1010.0,
        886.1214599609375,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.381051242351532,
        0.9245539903640747,
        0.0
      ],
      "plane_d": -434.4053649902344,
      "bbox_min": [
        1000.0,
        882.0,
        118.0
      ],
      "bbox_max": [
        1010.0,
        886.1214599609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        760.0,
        1040.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1279.9998779296875,
      "bbox_min": [
        775.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1279.9998779296875,
      "bbox_min": [
        760.0,
        1280.0,
        110.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        760.0,
        875.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        790.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1550.0,
        1690.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        790.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        790.0,
        1570.0,
        160.0
      ],
      "bbox_max": [
        1170.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        945.0,
        1580.0,
        160.0
      ],
      "bbox_max": [
        1170.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7241379618644714,
        0.0,
        0.6896552443504333
      ],
      "plane_d": 642.396240234375,
      "bbox_min": [
        955.0,
        1630.0,
        160.0
      ],
      "bbox_max": [
        1057.5947265625,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        955.0,
        1630.0,
        160.0
      ],
      "bbox_max": [
        980.0,
        1680.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        955.0,
        1655.0,
        160.0
      ],
      "bbox_max": [
        970.0,
        1664.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        970.0,
        1664.0,
        160.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        945.0,
        1580.0,
        160.0
      ],
      "bbox_max": [
        980.0,
        1630.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        945.0,
        1580.0,
        160.0
      ],
      "bbox_max": [
        954.0,
        1595.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 431.3350830078125,
      "bbox_min": [
        970.0,
        1580.0,
        160.0
      ],
      "bbox_max": [
        980.0,
        1590.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 431.3350830078125,
      "bbox_min": [
        954.0,
        1570.0,
        160.0
      ],
      "bbox_max": [
        970.0,
        1580.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        790.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1187.731689453125,
        1690.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 149.99998474121094,
      "bbox_min": [
        790.0,
        1580.0,
        140.0
      ],
      "bbox_max": [
        1187.731689453125,
        1690.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        945.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        1187.731689453125,
        1690.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.5947265625,
      "bbox_min": [
        955.0,
        1630.0,
        150.0
      ],
      "bbox_max": [
        1039.49951171875,
        1690.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7241379618644714,
        0.0,
        0.6896552443504333
      ],
      "plane_d": 642.396240234375,
      "bbox_min": [
        1037.5947265625,
        1630.0,
        158.0
      ],
      "bbox_max": [
        1039.49951171875,
        1690.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        955.0,
        1630.0,
        150.0
      ],
      "bbox_max": [
        980.0,
        1680.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        955.0,
        1655.0,
        150.0
      ],
      "bbox_max": [
        970.0,
        1664.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        970.0,
        1664.0,
        150.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        945.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        980.0,
        1630.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        945.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        954.0,
        1595.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 431.3350830078125,
      "bbox_min": [
        970.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        980.0,
        1590.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 1230.3658447265625,
      "bbox_min": [
        800.0,
        1580.0,
        140.0
      ],
      "bbox_max": [
        1187.731689453125,
        1690.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        945.0,
        1590.0,
        140.0
      ],
      "bbox_max": [
        1187.731689453125,
        1690.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.5947265625,
      "bbox_min": [
        950.0,
        1630.0,
        140.0
      ],
      "bbox_max": [
        1037.5947265625,
        1690.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -572.7564697265625,
      "bbox_min": [
        950.0,
        1630.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        955.0,
        1655.0,
        145.0000457763672
      ],
      "bbox_max": [
        960.0,
        1658.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        955.0,
        1655.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -572.7564697265625,
      "bbox_min": [
        945.0,
        1590.0,
        140.0
      ],
      "bbox_max": [
        960.0,
        1630.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        945.0,
        1590.0,
        145.0
      ],
      "bbox_max": [
        947.9999389648438,
        1595.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        945.0,
        1580.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1595.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 431.3350830078125,
      "bbox_min": [
        970.0,
        1580.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1590.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        954.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1580.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 431.3350830078125,
      "bbox_min": [
        954.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        970.0,
        1580.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        954.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        960.0,
        1580.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1030.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        760.0,
        875.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1550.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1660.0,
        995.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1470.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1220.0,
      "bbox_min": [
        1660.0,
        995.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        410.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1680.0,
      "bbox_min": [
        1660.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        280.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 1371.7872314453125,
      "bbox_min": [
        1660.0,
        1220.0,
        260.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": 1084.0,
      "bbox_min": [
        1750.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1235.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        1750.0,
        1235.0,
        140.0
      ],
      "bbox_max": [
        1755.0,
        1235.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        -0.0,
        -0.5999999642372131
      ],
      "plane_d": 1452.0,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1750.0,
        1400.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": 1084.0,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1750.0,
        1280.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1680.0,
        1250.0,
        220.0
      ],
      "bbox_max": [
        1700.0,
        1280.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        1695.0,
        1235.0,
        140.0
      ],
      "bbox_max": [
        1750.0,
        1235.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1695.0,
      "bbox_min": [
        1695.0,
        1235.0,
        140.0
      ],
      "bbox_max": [
        1710.0,
        1385.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        1695.0,
        1235.0,
        140.0
      ],
      "bbox_max": [
        1710.0,
        1235.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1700.0,
      "bbox_min": [
        1690.0,
        995.0,
        140.0
      ],
      "bbox_max": [
        1714.14208984375,
        1220.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 346.48236083984375,
      "bbox_min": [
        1700.0,
        1195.85791015625,
        140.0
      ],
      "bbox_max": [
        1714.14208984375,
        1220.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": 116.3343505859375,
      "bbox_min": [
        1700.0,
        1195.85791015625,
        310.0
      ],
      "bbox_max": [
        1714.14208984375,
        1220.0,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        1690.0,
        995.0,
        140.0
      ],
      "bbox_max": [
        1700.0,
        1210.0,
        325.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 1234.2078857421875,
      "bbox_min": [
        1690.0,
        995.0,
        140.0
      ],
      "bbox_max": [
        1700.0,
        1210.0,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 346.48236083984375,
      "bbox_min": [
        1690.0,
        1195.85791015625,
        140.0
      ],
      "bbox_max": [
        1700.0,
        1210.0,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": 116.3343505859375,
      "bbox_min": [
        1690.0,
        1195.85791015625,
        310.0
      ],
      "bbox_max": [
        1700.0,
        1210.0,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        760.0,
        875.0,
        140.0
      ],
      "bbox_max": [
        1660.0,
        1550.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1350.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1660.0,
        1550.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2162.533447265625,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        140.0
      ],
      "bbox_max": [
        1588.2841796875,
        1550.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        1549.9998779296875,
        1508.2841796875,
        140.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1550.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1350.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1450.0,
        714.2493896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1350.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1530.0,
        1450.0,
        714.2493896484375
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.213134765625,
      "bbox_min": [
        1350.0,
        1292.393798828125,
        140.0
      ],
      "bbox_max": [
        1507.24658203125,
        1450.0,
        714.2493896484375
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1969.644775390625,
      "bbox_min": [
        1372.393798828125,
        1292.393798828125,
        290.0
      ],
      "bbox_max": [
        1507.24658203125,
        1427.24658203125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2019.644775390625,
      "bbox_min": [
        1407.7491455078125,
        1327.7491455078125,
        290.0
      ],
      "bbox_max": [
        1507.24658203125,
        1427.24658203125,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 290.0,
      "bbox_min": [
        1443.1044921875,
        1363.1044921875,
        290.0
      ],
      "bbox_max": [
        1507.24658203125,
        1427.24658203125,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        1407.7491455078125,
        1327.7491455078125,
        340.0
      ],
      "bbox_max": [
        1471.8912353515625,
        1391.8912353515625,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1919.644775390625,
      "bbox_min": [
        1372.393798828125,
        1292.393798828125,
        390.0
      ],
      "bbox_max": [
        1436.535888671875,
        1356.535888671875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 390.0,
      "bbox_min": [
        1372.393798828125,
        1292.393798828125,
        390.0
      ],
      "bbox_max": [
        1436.535888671875,
        1356.535888671875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1350.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1615.0,
        1230.57275390625,
        465.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        1350.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1555.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1555.0,
      "bbox_min": [
        1555.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1555.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        1350.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1395.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -939.1484985351562,
      "bbox_min": [
        1350.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1130.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37631431221961975,
        0.9264920949935913,
        0.0
      ],
      "plane_d": -573.57470703125,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        141.0
      ],
      "bbox_max": [
        1505.5,
        1230.57275390625,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9211491346359253,
        -0.389210045337677,
        0.0
      ],
      "plane_d": 1858.0826416015625,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        141.0
      ],
      "bbox_max": [
        1505.5,
        1228.80517578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3131498396396637,
        -0.7712410092353821,
        0.5541882514953613
      ],
      "plane_d": 1329.209716796875,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        146.0
      ],
      "bbox_max": [
        1505.5,
        1228.80517578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3131498694419861,
        0.7712409496307373,
        0.5541881918907166
      ],
      "plane_d": -560.33056640625,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        146.0
      ],
      "bbox_max": [
        1505.5,
        1228.80517578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7378709316253662,
        -0.3116414248943329,
        0.5986869931221008
      ],
      "plane_d": 1398.631591796875,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        146.0
      ],
      "bbox_max": [
        1505.5,
        1228.80517578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.737870991230011,
        0.3116414248943329,
        0.5986870527267456
      ],
      "plane_d": 635.110107421875,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        146.0
      ],
      "bbox_max": [
        1505.5,
        1228.80517578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619802355766296,
        0.9265393614768982,
        0.0
      ],
      "plane_d": -569.3077392578125,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        146.0
      ],
      "bbox_max": [
        1505.5,
        1228.80517578125,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37631431221961975,
        -0.9264920949935913,
        0.0
      ],
      "plane_d": 1696.330810546875,
      "bbox_min": [
        1501.148193359375,
        1219.42724609375,
        146.0
      ],
      "bbox_max": [
        1505.5,
        1224.6627197265625,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619802355766296,
        -0.9265393614768982,
        0.0
      ],
      "plane_d": 1700.7138671875,
      "bbox_min": [
        1504.5679931640625,
        1224.2843017578125,
        148.0
      ],
      "bbox_max": [
        1505.5,
        1224.6627197265625,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9211491346359253,
        0.389210045337677,
        0.0
      ],
      "plane_d": 904.5179443359375,
      "bbox_min": [
        1499.5404052734375,
        1225.0,
        146.0
      ],
      "bbox_max": [
        1501.148193359375,
        1228.80517578125,
        148.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        1395.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1555.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1555.0,
      "bbox_min": [
        1555.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1555.0,
        1120.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        1395.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1445.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1405.0,
      "bbox_min": [
        1405.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1445.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1405.0,
        1100.0,
        465.0
      ],
      "bbox_max": [
        1445.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        760.0,
        875.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1550.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1130.0,
        250.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -939.1484985351562,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1130.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        760.0,
        875.0,
        140.0
      ],
      "bbox_max": [
        1240.0,
        1550.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        950.0,
        900.0,
        140.0
      ],
      "bbox_max": [
        1240.0,
        1280.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        950.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1280.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        950.0,
        1170.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25617516040802,
        -0.9666303992271423,
        0.0
      ],
      "plane_d": 1383.4095458984375,
      "bbox_min": [
        950.0,
        1170.0,
        280.0
      ],
      "bbox_max": [
        985.4664306640625,
        1179.3992919921875,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1000.0,
        1170.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1170.0,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9418852925300598,
        -0.33593469858169556,
        0.0
      ],
      "plane_d": -550.1356201171875,
      "bbox_min": [
        983.5406494140625,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        985.4664306640625,
        1166.1483154296875,
        140.0
      ],
      "bbox_max": [
        1001.373779296875,
        1170.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25617516040802,
        -0.9666303992271423,
        0.0
      ],
      "plane_d": 1383.4095458984375,
      "bbox_min": [
        985.4664306640625,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1000.0,
        1170.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1001.373779296875,
        1170.0,
        280.9158630371094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1166.1483154296875,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        950.0,
        924.773681640625,
        140.0
      ],
      "bbox_max": [
        1210.0,
        1119.199951171875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": -1114.3089599609375,
      "bbox_min": [
        1010.7999877929688,
        950.0,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1119.199951171875,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1010.7999877929688,
        950.0,
        140.0
      ],
      "bbox_max": [
        1160.0,
        1109.5999755859375,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1020.3999633789062,
        970.0,
        140.0
      ],
      "bbox_max": [
        1160.0,
        1109.5999755859375,
        380.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1050.0,
        1090.0,
        140.0
      ],
      "bbox_max": [
        1060.0,
        1109.5999755859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": 1016.0777587890625,
      "bbox_min": [
        1010.7999877929688,
        950.0,
        140.0
      ],
      "bbox_max": [
        1037.0,
        1109.5999755859375,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974522560834885
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        1010.7999877929688,
        950.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1109.5999755859375,
        380.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1010.7999877929688,
        960.4000244140625,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1083.3333740234375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1016.6666870117188,
        966.6666870117188,
        140.0
      ],
      "bbox_max": [
        1020.0,
        1083.3333740234375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": -1112.6187744140625,
      "bbox_min": [
        1010.7999877929688,
        1092.0,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1119.199951171875,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": 1016.0777587890625,
      "bbox_min": [
        1030.0,
        1092.0,
        380.0
      ],
      "bbox_max": [
        1037.0,
        1100.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974522560834885
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        1010.7999877929688,
        1100.0,
        140.0
      ],
      "bbox_max": [
        1169.5999755859375,
        1119.199951171875,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1040.4000244140625,
        1100.0,
        140.0
      ],
      "bbox_max": [
        1169.5999755859375,
        1119.199951171875,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1040.4000244140625,
        1100.0,
        140.0
      ],
      "bbox_max": [
        1163.3333740234375,
        1119.199951171875,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320502638816833,
        0.5547001957893372
      ],
      "plane_d": -1004.00732421875,
      "bbox_min": [
        1046.6666259765625,
        1110.0,
        140.0
      ],
      "bbox_max": [
        1163.3333740234375,
        1113.3333740234375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1093.0,
      "bbox_min": [
        1037.0,
        1093.0,
        580.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        950.0,
        924.773681640625,
        140.0
      ],
      "bbox_max": [
        1030.0,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1020.4000244140625,
        940.4000244140625,
        140.0
      ],
      "bbox_max": [
        1030.0,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9778024554252625,
        0.2095290869474411
      ],
      "plane_d": -975.0087280273438,
      "bbox_min": [
        950.0,
        924.773681640625,
        220.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        337.72265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1093.0,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1515.329833984375,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1160.0,
        1093.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7077255845069885,
        0.7064874172210693,
        0.0
      ],
      "plane_d": 48.61865234375,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1061.0999755859375,
        994.1422119140625,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 47.37615966796875,
      "bbox_min": [
        1135.85791015625,
        1068.85791015625,
        750.0
      ],
      "bbox_max": [
        1160.0,
        1093.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        760.0,
        875.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1190.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -1355.414306640625,
      "bbox_min": [
        861.330810546875,
        1120.0,
        170.0
      ],
      "bbox_max": [
        950.0,
        1190.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        861.330810546875,
        1120.0,
        170.0
      ],
      "bbox_max": [
        868.6692504882812,
        1121.3931884765625,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25617516040802,
        -0.9666303992271423,
        0.0
      ],
      "plane_d": 1383.4095458984375,
      "bbox_min": [
        910.0,
        1179.3992919921875,
        280.0
      ],
      "bbox_max": [
        950.0,
        1190.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        760.0,
        875.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1120.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112825989723206,
        0.4117816090583801,
        0.0
      ],
      "plane_d": -1293.248291015625,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1120.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112825989723206,
        -0.4117816090583801,
        0.0
      ],
      "plane_d": -432.6246337890625,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1120.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -1355.414306640625,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1120.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1120.0,
        170.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        -0.0
      ],
      "plane_d": -1335.414306640625,
      "bbox_min": [
        865.0,
        1006.109130859375,
        140.0
      ],
      "bbox_max": [
        925.0,
        1100.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112828373908997,
        0.4117811918258667,
        -0.0
      ],
      "plane_d": -1273.248046875,
      "bbox_min": [
        907.4263916015625,
        1006.109130859375,
        140.0
      ],
      "bbox_max": [
        925.0,
        1083.890869140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112828373908997,
        -0.4117811918258667,
        0.0
      ],
      "plane_d": -412.62530517578125,
      "bbox_min": [
        907.4263916015625,
        1006.109130859375,
        140.0
      ],
      "bbox_max": [
        925.0,
        1045.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9778024554252625,
        0.2095290869474411
      ],
      "plane_d": -975.0087280273438,
      "bbox_min": [
        760.0,
        875.0,
        220.0
      ],
      "bbox_max": [
        950.0,
        950.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        780.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1550.0,
        780.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1030.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        1030.0,
        1310.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.70710688829422,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -466.63031005859375,
      "bbox_min": [
        1030.0,
        1460.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1540.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1519.9998779296875,
      "bbox_min": [
        1030.0,
        1520.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1520.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      "bbox_max": [
        1175.0,
        1460.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.70710688829422,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -466.63031005859375,
      "bbox_min": [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1460.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071067094802856
      ],
      "plane_d": -476.6302490234375,
      "bbox_min": [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1330.0,
        375.9431457519531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1030.0,
        1280.0,
        160.0
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.70710688829422,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -466.63031005859375,
      "bbox_min": [
        780.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        370.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1309.9998779296875,
      "bbox_min": [
        780.0,
        1310.0,
        140.0
      ],
      "bbox_max": [
        820.0,
        1310.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1309.9998779296875,
      "bbox_min": [
        799.9147338867188,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        370.0852355957031
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071067094802856
      ],
      "plane_d": -476.6302490234375,
      "bbox_min": [
        854.056884765625,
        1520.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        355.9431457519531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27883198857307434,
        -0.9603399634361267,
        0.0
      ],
      "plane_d": 1215.2716064453125,
      "bbox_min": [
        929.0144653320312,
        1520.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        929.0144653320312,
        1520.0,
        140.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071067094802856
      ],
      "plane_d": -476.6302490234375,
      "bbox_min": [
        854.056884765625,
        1310.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1520.0,
        355.9431457519531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        0.6373907923698425,
        -0.0
      ],
      "plane_d": -1563.5732421875,
      "bbox_min": [
        890.0,
        1310.0,
        140.0
      ],
      "bbox_max": [
        945.5584716796875,
        1520.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1377.16455078125,
        140.0
      ],
      "bbox_max": [
        929.0144653320312,
        1520.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        890.0,
        1472.83544921875,
        140.0
      ],
      "bbox_max": [
        929.0144653320312,
        1520.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        945.5584716796875,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1310.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27883198857307434,
        0.9603399634361267,
        -0.0
      ],
      "plane_d": -1521.6973876953125,
      "bbox_min": [
        945.5584716796875,
        1300.0,
        160.0
      ],
      "bbox_max": [
        980.0,
        1310.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        480.0,
        1130.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1150.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -551.5433349609375,
      "bbox_min": [
        480.0,
        1130.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1150.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        480.0,
        1130.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1150.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        480.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1130.0,
        300.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        480.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        300.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        480.0,
        980.0,
        160.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -551.5433349609375,
      "bbox_min": [
        480.0,
        980.0,
        290.0
      ],
      "bbox_max": [
        490.0,
        1110.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        720.0,
        980.0,
        160.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        480.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        720.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        480.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        700.0,
        1090.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        700.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        700.0,
        1090.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        480.0,
        1110.0,
        118.0
      ],
      "bbox_max": [
        490.0,
        1130.0,
        300.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -551.5433349609375,
      "bbox_min": [
        480.0,
        1110.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1130.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        480.0,
        1110.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1130.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        480.0,
        1170.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1400.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        480.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        730.0,
        1352.5953369140625,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -551.5433349609375,
      "bbox_min": [
        480.0,
        1170.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        480.0,
        1170.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        0.30901700258255005,
        -0.0
      ],
      "plane_d": -1081.358154296875,
      "bbox_min": [
        699.5303955078125,
        1285.0,
        80.0
      ],
      "bbox_max": [
        730.0,
        1352.5953369140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8506503105163574,
        0.2763932943344116,
        0.4472144842147827
      ],
      "plane_d": -1011.917236328125,
      "bbox_min": [
        699.5303955078125,
        1285.0,
        80.0
      ],
      "bbox_max": [
        730.0,
        1352.5953369140625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        480.0,
        1150.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1170.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -551.5433349609375,
      "bbox_min": [
        480.0,
        1150.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1170.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        480.0,
        1150.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1170.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -551.5433349609375,
      "bbox_min": [
        440.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        480.0,
        1240.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        1090.0,
        80.0
      ],
      "bbox_max": [
        480.0,
        1240.0,
        190.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        440.0,
        1090.0,
        80.0
      ],
      "bbox_max": [
        480.0,
        1240.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        440.0,
        1090.0,
        80.0
      ],
      "bbox_max": [
        480.0,
        1130.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        440.0,
        1090.0,
        120.0
      ],
      "bbox_max": [
        480.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        440.0,
        1090.0,
        120.0
      ],
      "bbox_max": [
        480.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        440.0,
        1090.0,
        120.0
      ],
      "bbox_max": [
        480.0,
        1110.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -168.07418823242188,
      "bbox_min": [
        440.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        480.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        440.0,
        1110.0,
        98.0
      ],
      "bbox_max": [
        480.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        440.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        450.0,
        1130.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": -332.8201599121094,
      "bbox_min": [
        450.0,
        1110.0,
        98.99999237060547
      ],
      "bbox_max": [
        451.5,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": -332.8201599121094,
      "bbox_min": [
        451.5,
        1110.0,
        80.0
      ],
      "bbox_max": [
        480.0,
        1120.0,
        99.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}